<template>

  <PrimeToast />
  <ConfirmDialog />

  <!-- Success Dialog -->
  <PrimeDialog header="Success" v-model:visible="showSuccessDialog" modal>
    <p>{{ successMessage }}</p>
    <template #footer>
      <PrimeButton label="OK" icon="pi pi-check" @click="showSuccessDialog = false" />
    </template>
  </PrimeDialog>

  <!-- Email Duplicate Dialog -->
  <PrimeDialog header="Email Duplicate" v-model:visible="showEmailDuplicateDialog" modal>
    <p>The email supplied has already been used to fill an application</p>
    <!-- <p>The email supplied has alread been used to fill an application</p> -->
    <template #footer>
      <PrimeButton label="OK" @click="showEmailDuplicateDialog = false" />
    </template>
  </PrimeDialog>



  <!-- Completed Dialog -->
  <PrimeDialog header="Success" v-model:visible="showCompleteDialog" modal>
    <p>Application successfully submitted</p>
    <template #footer>
      <PrimeButton label="OK" icon="pi pi-check" @click="completeRedirect" />
    </template>
  </PrimeDialog>

  <!-- Error Dialog -->
  <PrimeDialog header="Oops!" v-model:visible="showErrorDialog" modal>
    <p>{{ errorMessage }}</p>
    <template #footer>
      <PrimeButton label="OK" icon="pi pi-check" @click="showErrorDialog = false" />
    </template>
  </PrimeDialog>


  <!-- Error Dialog -->
  <PrimeDialog header="Whoops!" v-model:visible="showRetryDialog" modal>
    <p>Whoops! Something went wrong...</p>
    <template #footer>
      <PrimeButton label="Retry" icon="pi pi-refresh" @click="sendToken" />

      <PrimeButton severity="danger" label="Cancel" icon="pi pi-times" @click="showRetryDialog = false" />
    </template>
  </PrimeDialog>



  <div class="grid ">

    <div
      class=" container-fluid  col-12 lg:col-offset-2 col-12 sm:col-offset-2  lg:col-9 md:col-8 p-2  border-round  align-items-center">
      <nav class="p-4 surface-0  shadow-1 border-round mb-3">
        <ul class="flex align-items-center justify-content-start list-none m-0 p-0">
          <li class="mr-4">
            <a href="https://greenfinancefacilitator.com" class="text-primary hover:text-primary-700">Home</a>
          </li>
          <li class="mr-4">
            <a href="#" @click="activateModule('main')" class="text-primary hover:text-primary-700">Application Form</a>
          </li>

          <li class="mr-4">
            <a href="#" @click="activateModule('resume')" class="text-primary hover:text-primary-700">Resume
              Application</a>
          </li>

        </ul>
      </nav>
      <!-- <div class="flex justify-content-between">
        <img class=" fadeinleft animation-duration-1000" height="100" src="@/assets/201119_ELdZ.png" alt="" srcset="">
        <img class="fadeinright animation-duration-1000" height="150" src="@/assets/201119_GIZ.png" alt="" srcset="">

      </div> -->

      <div v-if="start" class="startcss  ">

        <div class=" flex align-items-center justify-content-center p-2 bg-white-alpha-50 mb-2 h-20rem ">

          <div class="container-fluid grid gap-3 align-items-center">
            <div class="col-12 lg:col-6 bg-cyan-200 border-round">
              <h4>Online Application</h4>
              <p>Click on Start to start a new application or click on Resume to continue a previous application</p>
            </div>

            <div class="flex flex-column gap-3 col-12 lg:col-4">
              <PrimeButton @click="activateModule('main')" severity="success" label="Start" class="w-full" />

              <PrimeButton @click="activateModule('resume')" label="Resume" class="w-full" />
            </div>
          </div>
        </div>


      </div>
      <!----Resume/Retrieve form-->
      <div v-if="resume" style=" background-color: azure">

        <div class="col-12 md:col-5 md:col-offset-3">


          <PrimeCard>
            <template #header>
              <!-- <img alt="user header" src="/images/usercard.png" /> -->
            </template>
            <template #title>
              <h1 class="  text-2xl">Complete KYC form</h1>
            </template>
            <!-- <template #subtitle>Card subtitle</template> -->
            <template #content>
              <h4 v-if="!token_received" class="m-0">
                Enter the email used for the application. A confirmation token will be sent to that email.
              </h4>

              <div v-if="token_received" class="m-0">
                <h4>Token should arrive in your inbox within 5 minutes</h4>
                <div class="text-2xl font-bold text-info">{{ countDown }}</div>
                <PrimeButton :loading="sending_token" v-if="canResendToken" @click="sendToken" label="Resend...">
                </PrimeButton>
                <p> Enter token received and click on button to proceed</p>

              </div>
            </template>
            <template #footer>
              <div class="flex flex-column gap-3 mt-1">

                <div v-if="!token_received">
                  <FloatLabel class="mb-3">
                    <PrimeInputText v-model="retrieval_email" id="email" class="w-full" />
                    <label for="email">Email</label>
                  </FloatLabel>
                  <PrimeButton @click="sendToken" severity="success" :loading="sending_token" label="Send Token"
                    class="w-full" />
                </div>

                <div v-if="token_received">
                  <FloatLabel>
                    <PrimeInputText maxlength="8" v-model="token" class="w-full mb-3" id="token" />
                    <label for="token">Token</label>
                  </FloatLabel>

                  <PrimeButton :disabled="token == ''" :loading="sending_token" @click="retrieveForm" severity="success"
                    label="Resume Application" class="w-full" />
                </div>



              </div>
            </template>
          </PrimeCard>
        </div>

      </div>

      <div v-if="main" id="main">


        <div>
          <!-- <h1 class="  text-bluegray-700  p-1">SME APPLICATION FORM</h1> -->


          <!-- <div class="card flex flex-wrap gap-2 justify-content-center">
      <PrimeButton @click="confirm1()" label="OK" outlined></PrimeButton>
      <PrimeButton @click="confirm2()" label="Delete" severity="danger" outlined></PrimeButton>
  </div> -->
          <form @submit.prevent="submitConfirmation" class="form-container">
            <!-- Step One -->
            <div class="form-step">
              <h2>New Application</h2>
              <h3>Note!</h3>
              <h4 class="text-black-alpha-80">**All fields marked <b><span class="required">*</span></b> are mandatory.
              </h4>
              <h4 class=" text-black-alpha-80 ">**You can save your progress by clicking on the 'Save Progress' button
                at
                the end of the form.</h4>





              <!-- <div :class="{ error: v$.formData.photo.$errors.length }"></div>

              <label for="picture" class="form-label">Upload a Clear Picture of Yourself <span
                  class="required">*</span></label>

              

              <div class="input-errors" v-for="error of v$.formData.photo.$errors" :key="error.$uid">
                <div class="error-msg">{{ error.$message }}</div>
              </div> -->

              

              <div class="formgrid grid">

                <!-- <div class="col-12 mb-3">

                  <strong class=" text-gray-800 ">Download</strong>
                  <a :href="formPDFLink" class="mr-2" target="_blank" style="color:black"> <span class=" text-sm">
                      PDF</span> <i class="pi pi-file-pdf" style="font-size: 1.5rem; color:red"></i></a>

                  <a :href="formExcelLink" target="_blank" style="color:black"> <span class=" text-sm"> Excel</span>
                    <i class="pi pi-file-excel" style="font-size: 1.5rem; color:green"></i></a>


                </div> -->

                <!-- <div class="col-12 mb-3">
                  <div class="flex gap-3">

                    <div>
                      <a :href="formPDFLink" target="_blank" style="color:black"> <span class=" text-sm"> PDF</span> <i
                          class="pi pi-file-pdf" style="font-size: 1.5rem; color:red"></i></a>
                    </div>
                    <div>
                      <a :href="formExcelLink" target="_blank" style="color:black"> <span class=" text-sm">Excel</span>
                        <i class="pi pi-file-excel" style="font-size: 1.5rem; color:green"></i></a>
                    </div>

                  </div>


                </div> -->





                <!-- Contact Information -->
                <div class="col-12">
                  <PrimeCard class="">
                    <template #header>
                      <!-- <img alt="user header" src="/images/usercard.png" /> -->
                    </template>
                    <!-- <template #subtitle>Contact Information</template> -->
                    <!-- <template #subtitle>Card subtitle</template> -->
                    <template #content>

                      <!-- <div class="flex gap-2 flex-wrap flex-column lg:flex-row "> -->
                      <div class="grid">
                        <div class="col-12">
                          <h4>1. Contact Information</h4>
                          <p class="text-sm mb-4 required"><strong>Kindly complete this section before saving
                              progress.</strong></p>
                        </div>
                        


                        <div class="field  col-12 md:col-4">
                          <div :class="{ error: v$.formData.home_phone.$errors.length }"></div>
                          <label for="home_phone">Work Phone (10 Digits) </label>
                          <PrimeInputText v-model="formData.home_phone" maxlength="10" placeholder="e.g. 05XXXXXXXX"
                            class="w-full" id="home_phone" @blur="v$.formData.home_phone.$touch()" />
                          <div class="input-errors" v-for="error of v$.formData.home_phone.$errors" :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>

                      </div>

                    </template>
                    <template #footer>

                    </template>
                  </PrimeCard>
                </div>


                <!-- Business Information -->
                <div class="col-12 mt-4">
                  <PrimeCard class="">
                    <template #header>
                      <!-- <img alt="user header" src="/images/usercard.png" /> -->
                    </template>
                    <!-- <template #subtitle>
                    <h4>Business Information</h4>
                    </template> -->
                    <!-- <template #subtitle>Card subtitle</template> -->
                    <template #content>

                      <!-- <div class="flex gap-2 flex-wrap flex-column lg:flex-row "> -->
                      <div class="grid">

                        <div class="col-12">
                          <h4>2. Business Information</h4>
                        </div>

                        <div class="field col-12 md:col-6">
                          <div :class="{ error: v$.formData.business_name.$errors.length }"></div>
                          <label for="business_name">Business Name <span class="required">*</span></label>
                          <PrimeInputText :invalid="v$.formData.business_name.$errors.length > 0"
                            v-model="formData.business_name" class="w-full" @blur="v$.formData.business_name.$touch()"
                            id="business_name" />
                          <div class="input-errors" v-for="error of v$.formData.business_name.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>

                        <div class="field col-12 md:col-6">
                          <div :class="{ error: v$.formData.business_type.$errors.length }"></div>
                          <label for="business_type">Business Type <span class="required">*</span></label>


                          <PrimeDropdown :invalid="v$.formData.business_type.$errors.length > 0" id="business_type"
                            class="w-full" v-model="formData.business_type" :options="$menus.business_types_options"
                            optionLabel="label" optionValue="value" @blur="v$.formData.business_type.$touch()"
                            placeholder="Select Type" />


                          <div class="input-errors" v-for="error of v$.formData.business_type.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>



                        <div class="field col-12 md:col-12">
                          <div :class="{ error: v$.formData.business_description.$errors.length }"></div>
                          <label for="business_description">Business Description.<span class="required">*</span>
                            <br><span class="required">This information is important for the
                              initial screening of applications, It is okay to copy a description from your business
                              plan,
                              but please provide more than a single sentence that explains what the company does and how
                              it is "green".</span> </label>

                          <TextArea :invalid="v$.formData.business_description.$errors.length > 0" rows="5"
                            type="TextArea" v-model="formData.business_description" class="w-full"
                            @blur="v$.formData.business_description.$touch()" id="business_description">


                          </TextArea>

                        </div>

                        <div class="field col-12 md:col-6">
                          <div :class="{ error: v$.formData.business_address.$errors.length }"></div>
                          <label for="business_address">Business Address <span class="required">*</span></label>
                          <TextArea :invalid="v$.formData.business_address.$errors.length > 0" rows="1"
                            v-model="formData.business_address" class="w-full"
                            @blur="v$.formData.business_address.$touch()" id="business_address"></TextArea>

                          <div class="input-errors" v-for="error of v$.formData.business_address.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>


                        <div class="field col-12 md:col-6">
                          <div :class="{ error: v$.formData.business_digital_address.$errors.length }"></div>
                          <label for="business_digital_address">Business Digital Address(Email)<span
                              class="required">*</span></label>
                          <PrimeInputText :invalid="v$.formData.business_digital_address.$errors.length > 0"
                            v-model="formData.business_digital_address" class="w-full"
                            @blur="v$.formData.business_digital_address.$touch()" id="business_digital_address" />
                          <div class="input-errors" v-for="error of v$.formData.business_digital_address.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>



                        <div class="field col-12 md:col-6">
                          <div :class="{ error: v$.formData.business_website.$errors.length }"></div>
                          <label for="business_website">Business Website/Social Media <span
                              class="required">*</span></label>
                          <PrimeInputText :invalid="v$.formData.business_website.$errors.length > 0"
                            v-model="formData.business_website" class="w-full"
                            @blur="v$.formData.business_website.$touch()" id="business_website" />
                          <div class="input-errors" v-for="error of v$.formData.business_website.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>



                        <div class="col-12 mt-4 mb-4">
                          <PrimeCard class=" p-1 shadow-1"> ">
                            <template #header>
                              <h4>Number of Staff</h4>
                              <!-- <img alt="user header" src="/images/usercard.png" /> -->
                            </template>
                            <template #subtitle>

                            </template>
                            <!-- <template #subtitle>Card subtitle</template> -->
                            <template #content>

                              <!-- <div class="flex gap-2 flex-wrap flex-column lg:flex-row "> -->
                              <div class="grid">



                                <div class="field col-12 md:col-3">



                                  <div :class="{ error: v$.formData.fulltime_staff.$errors.length }"></div>
                                  <label for="fulltime_staff"> Full Time Staff <span class="required">*</span></label>

                                  <InputNumber :invalid="v$.formData.fulltime_staff.$errors.length > 0"
                                    v-model="formData.fulltime_staff" :max="9999" class="w-full"
                                    @blur="v$.formData.fulltime_staff.$touch()" id="fulltime_staff" />


                                  <div class="input-errors" v-for="error of v$.formData.fulltime_staff.$errors"
                                    :key="error.$uid">
                                    <div class="error-msg">{{ error.$message }}</div>
                                  </div>
                                </div>


                                <div class="field col-12 md:col-3">



                                  <div :class="{ error: v$.formData.parttime_staff.$errors.length }"></div>
                                  <label for="parttime_staff"> Part-Time/Contract Staff <span
                                      class="required">*</span></label>

                                  <InputNumber :invalid="v$.formData.parttime_staff.$errors.length > 0"
                                    v-model="formData.parttime_staff" :max="9999" class="w-full"
                                    @blur="v$.formData.parttime_staff.$touch()" id="parttime_staff" />


                                  <div class="input-errors" v-for="error of v$.formData.parttime_staff.$errors"
                                    :key="error.$uid">
                                    <div class="error-msg">{{ error.$message }}</div>
                                  </div>
                                </div>


                                <div class="field col-12 md:col-3">



                                  <div :class="{ error: v$.formData.male_staff.$errors.length }"></div>
                                  <label for="male_staff"> Number of Male Staff <span class="required">*</span></label>

                                  <InputNumber :invalid="v$.formData.male_staff.$errors.length > 0"
                                    v-model="formData.male_staff" :max="9999" class="w-full"
                                    @blur="v$.formData.male_staff.$touch()" id="male_staff" />


                                  <div class="input-errors" v-for="error of v$.formData.male_staff.$errors"
                                    :key="error.$uid">
                                    <div class="error-msg">{{ error.$message }}</div>
                                  </div>
                                </div>

                                <div class="field col-12 md:col-3">
                                  <div :class="{ error: v$.formData.female_staff.$errors.length }"></div>
                                  <label for="female_staff">Number of Female Staff <span
                                      class="required">*</span></label>

                                  <InputNumber :invalid="v$.formData.female_staff.$errors.length > 0"
                                    v-model="formData.female_staff" :max="9999" class="w-full"
                                    @blur="v$.formData.female_staff.$touch()" id="female_staff" />


                                  <div class="input-errors" v-for="error of v$.formData.female_staff.$errors"
                                    :key="error.$uid">
                                    <div class="error-msg">{{ error.$message }}</div>
                                  </div>
                                </div>


                                <div class="field col-12 md:col-3">
                                  <div :class="{ error: v$.formData.expected_staff_size.$errors.length }"></div>
                                  <label for="expected_staff_size">Expected Staff Size Post Funding <span
                                      class="required">*</span></label>

                                  <!-- <PrimeInputText :invalid="v$.formData.expected_staff_size.$errors.length > 0"
                                    v-model="formData.expected_staff_size" class="w-full"
                                    @blur="v$.formData.expected_staff_size.$touch()" id="expected_staff_size" /> -->

                                  <InputNumber :invalid="v$.formData.expected_staff_size.$errors.length > 0"
                                    v-model="formData.expected_staff_size" :max="9999" class="w-full"
                                    @blur="v$.formData.expected_staff_size.$touch()" id="expected_staff_size" />

                                  <div class="input-errors" v-for="error of v$.formData.expected_staff_size.$errors"
                                    :key="error.$uid">
                                    <div class="error-msg">{{ error.$message }}</div>
                                  </div>
                                </div>
                              </div>


                            </template>
                            <template #footer>

                            </template>
                          </PrimeCard>

                        </div>





                        <!-- <div class="field col-12 md:col-4">


                          <div :class="{ error: v$.formData.male_staff.$errors.length }"></div>
                          <label for="male_staff"> Number of Male Staff <span class="required">*</span></label>

                          <InputNumber :invalid="v$.formData.male_staff.$errors.length > 0"
                            v-model="formData.male_staff" :max="9999" class="w-full"
                            @blur="v$.formData.male_staff.$touch()" id="male_staff" />


                          <div class="input-errors" v-for="error of v$.formData.male_staff.$errors" :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>

                        <div class="field col-12 md:col-4">
                          <div :class="{ error: v$.formData.female_staff.$errors.length }"></div>
                          <label for="female_staff">Number of Female Staff <span class="required">*</span></label>

                          <InputNumber :invalid="v$.formData.female_staff.$errors.length > 0"
                            v-model="formData.female_staff" :max="9999" class="w-full"
                            @blur="v$.formData.female_staff.$touch()" id="female_staff" />


                          <div class="input-errors" v-for="error of v$.formData.female_staff.$errors" :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>
                        <div class="field col-12 md:col-4">
                          <div :class="{ error: v$.formData.expected_staff_size.$errors.length }"></div>
                          <label for="expected_staff_size">Expected Staff Size Post Funding <span
                              class="required">*</span></label>
                          <PrimeInputText :invalid="v$.formData.expected_staff_size.$errors.length > 0"
                            v-model="formData.expected_staff_size" class="w-full"
                            @blur="v$.formData.expected_staff_size.$touch()" id="expected_staff_size" />
                          <div class="input-errors" v-for="error of v$.formData.expected_staff_size.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div> -->

                        <!-- <div class="field col-12 ">
                          <div :class="{ error: v$.formData.sector.$errors.length }"></div>
                          <label for="sector">Which Green Sector of Operation does your business operate? Please see the
                            Project
                            Eligibility & Application Guidelines (available for download from the website) for
                            information. The
                            sector you select and the nature of your business will be used to determine eligibility.
                            <span class="required">*</span></label>



                          <PrimeDropdown :invalid="v$.formData.sector.$errors.length > 0" id="sector" class="w-full"
                            v-model="formData.sector" :options="$menus.sectors" optionLabel="label" optionValue="value"
                            @blur="v$.formData.sector.$touch()" placeholder="Select Sector" />

                        </div> -->

                        <div class="col-12 mt-4 mb-4">
                          <PrimeCard class=" p-1 shadow-1"> ">
                            <template #header>
                              <h5>Which Green Sector of Operation does your business operate?<br><br><span
                                  class="required">Please see the
                                  Project
                                  Eligibility & Application Guidelines (available for download from the website) for
                                  information. The
                                  sector you select and the nature of your business will be used to determine
                                  eligibility.</span>
                              </h5>
                              <!-- <img alt="user header" src="/images/usercard.png" /> -->
                            </template>
                            <template #subtitle>

                            </template>
                            <!-- <template #subtitle>Card subtitle</template> -->
                            <template #content>

                              <!-- <div class="flex gap-2 flex-wrap flex-column lg:flex-row "> -->
                              <div class="grid">
                                <div class="field col-12 md:col-6">
                                  <div :class="{ error: v$.formData.sector_json.$errors.length }"></div>
                                  <label for="sector_json">Sector <span class="required">*</span></label>


                                  <PrimeDropdown :invalid="v$.formData.sector_json.$errors.length > 0" id="sector_json"
                                    class="w-full" v-model="formData.sector_json" :options="sectorOptions"
                                    optionLabel="name" @blur="v$.formData.sector_json.$touch()"
                                    @change="populateSubsector" placeholder="Select sector">

                                    <template #value="slotProps">
                                      <span v-if="slotProps.value">
                                        {{ slotProps.value.code }} - {{ slotProps.value.name }}
                                      </span>
                                      <span v-else class="p-placeholder">Select sector</span>
                                    </template>



                                    <template #option="slotProps">
                                      <span v-if="slotProps.option">
                                        {{ slotProps.option.code }} - {{ slotProps.option.name }}
                                      </span>
                                      <span v-else class="p-placeholder">Select sector</span>
                                    </template>

                                  </PrimeDropdown>


                                  <div class="input-errors" v-for="error of v$.formData.sector_json.$errors"
                                    :key="error.$uid">
                                    <div class="error-msg">{{ error.$message }}</div>
                                  </div>
                                </div>


                                <div class="field col-12 md:col-6">
                                  <div :class="{ error: v$.formData.subsector_json.$errors.length }"></div>
                                  <label for="subsector_json">Sub-sector <span class="required">*</span></label>


                                  <PrimeDropdown :invalid="v$.formData.subsector_json.$errors.length > 0"
                                    id="subsector_json" class="w-full" v-model="formData.subsector_json"
                                    :options="subsectorOptions" optionLabel="name"
                                    @blur="v$.formData.subsector_json.$touch()" placeholder="Select sub-sector">

                                    <!-- Selected Value Template -->
                                    <template #value="slotProps">
                                      <span v-if="slotProps.value">
                                        {{ slotProps.value.code }} - {{ slotProps.value.name }}
                                      </span>
                                      <span v-else class="p-placeholder">Select sector</span>
                                    </template>


                                    <template #option="slotProps">
                                      <span v-if="slotProps.option">
                                        {{ slotProps.option.code }} - {{ slotProps.option.name }}
                                      </span>
                                      <span v-else class="p-placeholder">Select sub-sector</span>
                                    </template>


                                  </PrimeDropdown>


                                  <div class="input-errors" v-for="error of v$.formData.subsector_json.$errors"
                                    :key="error.$uid">
                                    <div class="error-msg">{{ error.$message }}</div>
                                  </div>
                                </div>


                                <div v-if="formData.subsector == 'Other'" class="field col-12 md:col-4">
                                  <div :class="{ error: v$.formData.other_sector.$errors.length }"></div>
                                  <label for="other_sector">Specify Other Subsector <span
                                      class="required">*</span></label>
                                  <PrimeInputText :invalid="v$.formData.other_sector.$errors.length > 0"
                                    v-model="formData.other_sector" class="w-full"
                                    @blur="v$.formData.other_sector.$touch()" id="other_sector" />
                                  <div class="input-errors" v-for="error of v$.formData.other_sector.$errors"
                                    :key="error.$uid">
                                    <div class="error-msg">{{ error.$message }}</div>
                                  </div>
                                </div>


                              </div>


                            </template>
                            <template #footer>

                            </template>
                          </PrimeCard>

                        </div>





                        <div class="col-12">
                          <h4>Ownership Information</h4>
                        </div>

                        <div v-for="(owner, id) in ownership" v-bind:key="id" class="grid align-items-end">
                          <div class="field col-4">

                            <label for="male_staff">Name of Owner and Role (if any) <span
                                class="required">*</span></label>
                            <PrimeInputText v-model="owner.name" class="w-full" id="male_staff" />

                          </div>

                          <div class="field col-3">

                            <label for="male_staff">Percentage of Ownership <span class="required">*</span></label>
                            <PrimeInputText v-model="owner.percentage" class="w-full" id="male_staff" />
                            <!-- <div class="input-errors" v-for="error of v$.formData.male_staff.$errors" :key="error.$uid">
                              <div class="error-msg">{{ error.$message }}</div>
                            </div> -->
                          </div>

                          <div class="field col-3">
                            <!-- <div :class="{ error: v$.formData.male_staff.$errors.length }"></div> -->
                            <label for="owner_gender">Gender<span class="required">*</span></label>


                            <PrimeDropdown id="owner_gender" class="w-full" v-model="owner.gender"
                              :options="$menus.genderOptions" optionLabel="label" optionValue="value"
                              placeholder="Select gender" />

                            <!-- <PrimeInputText v-model="owner.role" class="w-full" id="male_staff" /> -->
                            <!-- <div class="input-errors" v-for="error of v$.formData.male_staff.$errors" :key="error.$uid">
                              <div class="error-msg">{{ error.$message }}</div>
                            </div> -->
                          </div>


                          <!-- <div class="field col-3">
                            
                            <label for="owner_gender">Gender<span class="required">*</span></label>


                            <PrimeDropdown  id="owner_gender" class="w-full"
                            v-model="owner.gender" :options="$menus.genderOptions" optionLabel="label" optionValue="value"
                            placeholder="Select gender" />

                           
                          </div> -->

                          <div class="field col-2 ">

                            <PrimeButton type="button" label="Delete" icon="pi pi-trash" @click="removeOwner(id)"
                              severity="danger" />


                          </div>


                        </div>
                        <div class="col-3">
                          <PrimeButton type="button" label="Add Owner" icon="pi pi-plus" @click="addOwner"
                            severity="success" />
                        </div>



                        <!-- <div class="col-12 mb-4">
                          <div class="col">
                            <h4>Social Media Handles</h4>
                          </div>
                          <div v-for="(smedia, id) in social_media_platforms" v-bind:key="id"
                            class="grid align-items-end">
                            <div class="field col-3">

                              <label for="male_staff">Platform<span class="required">*</span></label>
                            
                              <PrimeDropdown id="business_type" class="w-full" v-model="smedia.platform"
                                :options="platformOptions" optionLabel="label" optionValue="value"
                                placeholder="Select Platform.." />

                            </div>

                            <div class="field col-3">

                              <label for="male_staff">Handle <span class="required">*</span></label>
                              <PrimeInputText v-model="smedia.handle" class="w-full" id="male_staff" />
                            
                            </div>


                            <div class="field col-2 ">

                              <PrimeButton type="button" label="Delete" icon="pi pi-trash" @click="removeOwner(id)"
                                severity="danger" />


                            </div>


                          </div>
                          <div class="col-3">
                            <PrimeButton type="button" label="Add Handle" icon="pi pi-plus" @click="addOwner"
                              severity="success" />
                          </div>
                        </div> -->
                      </div>

                    </template>
                    <template #footer>

                    </template>
                  </PrimeCard>
                </div>

                <!-- Financials -->
                <div class="col-12 mt-4">
                  <PrimeCard class="">
                    <template #header>
                      <!-- <img alt="user header" src="/images/usercard.png" /> -->
                    </template>
                    <!-- <template #subtitle>Financial Information</template> -->
                    <!-- <template #subtitle>Card subtitle</template> -->
                    <template #content>

                      <!-- <div class="flex gap-2 flex-wrap flex-column lg:flex-row "> -->
                      <div class="grid">
                        <div class="col-12">
                          <h4>3. Financial Information</h4>
                          <p>Note: All figures are in Ghana Cedis (GHS)</p>

                        </div>

                        <div class="grid mx-5">
                          <div class="field col-12 md:col-4">
                          <div :class="{ error: v$.formData.sales_revenue_2021.$errors.length }"> </div>

                          <label for="sales_revenue_2021">Sales Revenue 2021 <span class="required">*</span></label>

                          <InputNumber :invalid="v$.formData.sales_revenue_2021.$errors.length > 0"
                            v-model="formData.sales_revenue_2021" :max="9999999999999" class="w-full"
                            id="sales_revenue_2021" mode="currency" currency="GHS" :minFractionDigits="2"
                            :maxFractionDigits="5" />

                          <!-- <PrimeInputText :invalid="v$.formData.sales_revenue_2021.$errors.length > 0"
                            v-model="formData.sales_revenue_2021" class="w-full" id="sales_revenue_2021" /> -->

                          <div class="input-errors" v-for="error of v$.formData.sales_revenue_2021.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>


                        </div>

                        <div class="field col-12 md:col-4">
                          <div :class="{ error: v$.formData.sales_revenue_2022.$errors.length }"> </div>

                          <label for="sales_revenue_2022">Sales Revenue 2022 <span class="required">*</span></label>

                          <InputNumber :invalid="v$.formData.sales_revenue_2022.$errors.length > 0"
                            v-model="formData.sales_revenue_2022" :max="9999999999999" class="w-full"
                            id="sales_revenue_2022" mode="currency" currency="GHS" :minFractionDigits="2"
                            :maxFractionDigits="5" />
                          <!-- <PrimeInputText :invalid="v$.formData.sales_revenue_2022.$errors.length > 0"
                            v-model="formData.sales_revenue_2022" class="w-full" id="sales_revenue_2022" /> -->

                          <div class="input-errors" v-for="error of v$.formData.sales_revenue_2022.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>


                        </div>

                        <div class="field col-12 md:col-4">
                          <div :class="{ error: v$.formData.sales_revenue_2023.$errors.length }"> </div>

                          <label for="sales_revenue_2023">Sales Revenue 2023 <span class="required">*</span></label>

                          <InputNumber :invalid="v$.formData.sales_revenue_2023.$errors.length > 0"
                            v-model="formData.sales_revenue_2023" class="w-full" id="sales_revenue_2023" mode="currency"
                            currency="GHS" :minFractionDigits="2" :max="9999999999999" :maxFractionDigits="5" />

                          <!-- <PrimeInputText :invalid="v$.formData.sales_revenue_2023.$errors.length > 0"
                            v-model="formData.sales_revenue_2023" class="w-full" id="sales_revenue_2023" /> -->

                          <div class="input-errors" v-for="error of v$.formData.sales_revenue_2023.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>


                        </div>

                        <div class="field col-12 md:col-4">
                          <div :class="{ error: v$.formData.ebitda_2021.$errors.length }"> </div>

                          <label for="ebitda_2021">EBITDA 2021 <span class="required">*</span></label>

                          <InputNumber :invalid="v$.formData.ebitda_2021.$errors.length > 0"
                            v-model="formData.ebitda_2021" :max="9999999999999" class="w-full" id="ebitda_2021"
                            mode="currency" currency="GHS" :minFractionDigits="2" :maxFractionDigits="5" />
                          <!-- <PrimeInputText :invalid="v$.formData.ebitda_2021.$errors.length > 0"
                            v-model="formData.ebitda_2021" class="w-full" id="ebitda_2021" /> -->

                          <div class="input-errors" v-for="error of v$.formData.ebitda_2021.$errors" :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>


                        </div>

                        <div class="field col-12 md:col-4">
                          <div :class="{ error: v$.formData.ebitda_2022.$errors.length }"> </div>

                          <label for="ebitda_2022">EBITDA 2022 <span class="required">*</span></label>

                          <InputNumber :invalid="v$.formData.ebitda_2022.$errors.length > 0"
                            v-model="formData.ebitda_2022" :max="9999999999999" class="w-full" id="ebitda_2022"
                            mode="currency" currency="GHS" :minFractionDigits="2" :maxFractionDigits="5" />

                          <!-- <PrimeInputText :invalid="v$.formData.ebitda_2022.$errors.length > 0"
                            v-model="formData.ebitda_2022" class="w-full" id="ebitda_2022" /> -->

                          <div class="input-errors" v-for="error of v$.formData.ebitda_2022.$errors" :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>


                        </div>

                        <div class="field col-12 md:col-4">
                          <div :class="{ error: v$.formData.ebitda_2023.$errors.length }"> </div>

                          <label for="ebitda_2023">EBITDA 2023 <span class="required">*</span></label>

                          <InputNumber :invalid="v$.formData.ebitda_2023.$errors.length > 0"
                            v-model="formData.ebitda_2023" :max="9999999999999" class="w-full" id="ebitda_2023"
                            mode="currency" currency="GHS" :minFractionDigits="2" :maxFractionDigits="5" />

                          <!-- <PrimeInputText :invalid="v$.formData.ebitda_2023.$errors.length > 0"
                            v-model="formData.ebitda_2023" class="w-full" id="ebitda_2023" /> -->

                          <div class="input-errors" v-for="error of v$.formData.ebitda_2023.$errors" :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>


                        </div>
                        <div class="col-12">
                          <label class="required">** EBITDA - Earnings Before Interest, Taxes, Depreciation, and
                            Amortization</label>


                        </div>

                      </div>

                      


                        

                        <div class="col-12 mb-5 mt-5">
                          <PrimeCard  class="">
                            <template #header>
                              <!-- <img alt="user header" src="/images/usercard.png" /> -->
                            </template>

                            <template #content>
                              <div class="grid">
                                <div class="col-12 mb-2">
                                  <h4>What is your financing needs? Indicate whether amounts are in GHC, USD or EUR</h4>
                                </div>


                                <div class="field col-12 md:col-2">
                                  <div :class="{ error: v$.formData.finance_currency.$errors.length }"></div>
                                  <label for="finance_currency">Currency<span class="required">*</span></label>

                                  <PrimeDropdown :invalid="v$.formData.finance_currency.$errors.length > 0"
                                    id="finance_currency" class="w-full" v-model="formData.finance_currency"
                                    :options="$menus.currencyOptions" optionLabel="label" optionValue="value"
                                    @blur="v$.formData.finance_currency.$touch()" placeholder="Select..." />



                                  <div class="input-errors" v-for="error of v$.formData.finance_currency.$errors"
                                    :key="error.$uid">
                                    <div class="error-msg">{{ error.$message }}</div>
                                  </div>
                                </div>

                                <div class="field col-12 md:col-3">
                                  <div :class="{ error: v$.formData.grantt.$errors.length }"> </div>

                                  <label for="grantt">Grant<span class="required">*</span></label>

                                  <InputNumber :invalid="v$.formData.grantt.$errors.length > 0"
                                    v-model="formData.grantt" class="w-full" id="grantt" :max="9999999999999"
                                    mode="currency"
                                    :currency="formData.finance_currency ? formData.finance_currency : 'GHS'"
                                    :minFractionDigits="2" :maxFractionDigits="5" />
                                  <span class=" text-sm">Input 0 if not applicable</span>

                                  <!-- <PrimeInputText :invalid="v$.formData.debt.$errors.length > 0" v-model="formData.debt"
                            class="w-full" id="debt" /> -->

                                  <div class="input-errors" v-for="error of v$.formData.grantt.$errors"
                                    :key="error.$uid">
                                    <div class="error-msg">{{ error.$message }}</div>
                                  </div>


                                </div>


                                <div class="field col-12 md:col-3">
                                  <div :class="{ error: v$.formData.debt.$errors.length }"> </div>

                                  <label for="debt">Debt<span class="required">*</span></label>

                                  <InputNumber :invalid="v$.formData.debt.$errors.length > 0" v-model="formData.debt"
                                    class="w-full" id="debt" :max="9999999999999" mode="currency"
                                    :currency="formData.finance_currency ? formData.finance_currency : 'GHS'"
                                    :minFractionDigits="2" :maxFractionDigits="5" />
                                  <span class=" text-sm">Input 0 if not applicable</span>

                                  <!-- <PrimeInputText :invalid="v$.formData.debt.$errors.length > 0" v-model="formData.debt"
                            class="w-full" id="debt" /> -->

                                  <div class="input-errors" v-for="error of v$.formData.debt.$errors" :key="error.$uid">
                                    <div class="error-msg">{{ error.$message }}</div>
                                  </div>


                                </div>

                                <div class="field col-12 md:col-4">
                                  <div :class="{ error: v$.formData.equity.$errors.length }"> </div>

                                  <label for="equity">Equity <span class="required">*</span></label>

                                  <InputNumber :invalid="v$.formData.equity.$errors.length > 0"
                                    v-model="formData.equity" class="w-full" id="equity" :max="9999999999999"
                                    mode="currency"
                                    :currency="formData.finance_currency ? formData.finance_currency : 'GHS'"
                                    :minFractionDigits="2" :maxFractionDigits="5" />
                                  <span class=" text-sm">Input 0 if not applicable</span>
                                  <!-- <PrimeInputText :invalid="v$.formData.equity.$errors.length > 0" v-model="formData.equity"
                            class="w-full" id="equity" /> -->

                                  <div class="input-errors" v-for="error of v$.formData.equity.$errors"
                                    :key="error.$uid">
                                    <div class="error-msg">{{ error.$message }}</div>
                                  </div>


                                </div>

                                <div class="field col-12 md:col-12">
                                  <div :class="{ error: v$.formData.finance_purpose.$errors.length }"></div>
                                  <label for="finance_purpose">What do you need this financing for? Please describe.
                                    <span class="required">*</span></label>
                                  <TextArea :invalid="v$.formData.finance_purpose.$errors.length > 0" rows="5"
                                    v-model="formData.finance_purpose" class="w-full"
                                    @blur="v$.formData.finance_purpose.$touch()" id="finance_purpose"></TextArea>

                                  <div class="input-errors" v-for="error of v$.formData.finance_purpose.$errors"
                                    :key="error.$uid">
                                    <div class="error-msg">{{ error.$message }}</div>
                                  </div>
                                </div>
                              </div>
                            </template>

                            <template #footer>

                            </template>
                          </PrimeCard>
                        </div>

                        
                     




                        <div class="field col-12 md:col-6">
                          <div :class="{ error: v$.formData.funding_beneficiary.$errors.length }"></div>
                          <label for="funding_beneficiary">Are you currently a beneficiary of any funding?<span
                              class="required">*</span></label>

                          <PrimeDropdown :invalid="v$.formData.funding_beneficiary.$errors.length > 0"
                            id="funding_beneficiary" class="w-full" v-model="formData.funding_beneficiary"
                            :options="$menus.yesNoOptions" optionLabel="label" optionValue="value"
                            @blur="v$.formData.funding_beneficiary.$touch()" placeholder="Select..." />



                          <div class="input-errors" v-for="error of v$.formData.funding_beneficiary.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>

                        <div v-if="formData.funding_beneficiary == 'Yes'" class="field col-12 md:col-6">
                          <div :class="{ error: v$.formData.funder.$errors.length }"></div>
                          <label for="funder">If Yes Specify <span class="required">*</span></label>

                          <!-- <PrimeInputText :invalid="v$.formData.funder.$errors.length > 0" v-model="formData.funder"
                            class="w-full" @blur="v$.formData.funder.$touch()" id="funder" /> -->


                            <TextArea :invalid="v$.formData.funder.$errors.length > 0" rows="1"
                                    v-model="formData.funder" class="w-full"
                                    @blur="v$.formData.funder.$touch()" id="funder"></TextArea>


                          <div class="input-errors" v-for="error of v$.formData.funder.$errors" :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>


                        <div class="field col-12 md:col-6">
                          <div :class="{ error: v$.formData.audited_business.$errors.length }"></div>
                          <label for="audited_business">Has the business been audited in the past 3 years? <span
                              class="required">*</span></label>

                          <PrimeDropdown :invalid="v$.formData.audited_business.$errors.length > 0"
                            id="audited_business" class="w-full" v-model="formData.audited_business"
                            :options="$menus.yesNoOptions" optionLabel="label" optionValue="value"
                            @blur="v$.formData.audited_business.$touch()" placeholder="Select..." />



                          <div class="input-errors" v-for="error of v$.formData.audited_business.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>

                        <div v-if="formData.audited_business == 'Yes'" class="field col-12 md:col-6">
                          <div :class="{ error: v$.formData.auditor_name.$errors.length }"></div>
                          <label for="auditor_name">If Yes, Name of Auditors <span class="required">*</span></label>

                          <!-- <PrimeInputText :invalid="v$.formData.auditor_name.$errors.length > 0"
                            v-model="formData.auditor_name" class="w-full" @blur="v$.formData.auditor_name.$touch()"
                            id="auditor_name" /> -->


                            <TextArea :invalid="v$.formData.auditor_name.$errors.length > 0" rows="1"
                                    v-model="formData.auditor_name" class="w-full"
                                    @blur="v$.formData.auditor_name.$touch()" id="auditor_name"></TextArea>




                          <div class="input-errors" v-for="error of v$.formData.auditor_name.$errors" :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>


                        <div class="field col-12 md:col-6">
                          <div :class="{ error: v$.formData.outstanding_grant.$errors.length }"></div>
                          <label for="outstanding_grant">Do you currently have any debt or grant funding
                            outstanding?<span class="required">*</span></label>

                          <PrimeDropdown :invalid="v$.formData.outstanding_grant.$errors.length > 0"
                            id="outstanding_grant" class="w-full" v-model="formData.outstanding_grant"
                            :options="$menus.yesNoOptions" optionLabel="label" optionValue="value"
                            @blur="v$.formData.outstanding_grant.$touch()" placeholder="Select..." />



                          <div class="input-errors" v-for="error of v$.formData.outstanding_grant.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>

                        <div v-if="formData.outstanding_grant == 'Yes'" class="field col-12 md:col-6">
                          <div :class="{ error: v$.formData.grant_description.$errors.length }"></div>
                          <label for="grant_description">If yes, please describe: <span
                              class="required">*</span></label>




                          <!-- <PrimeInputText :invalid="v$.formData.grant_description.$errors.length > 0"
                            v-model="formData.grant_description" class="w-full"
                            @blur="v$.formData.grant_description.$touch()" id="grant_description" /> -->

                            <TextArea :invalid="v$.formData.grant_description.$errors.length > 0" rows="1"
                                    v-model="formData.grant_description" class="w-full"
                                    @blur="v$.formData.grant_description.$touch()" id="grant_description"></TextArea>
                            



                          <div class="input-errors" v-for="error of v$.formData.grant_description.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>


                        <div class="field col-12 md:col-6">
                          <div :class="{ error: v$.formData.past_technical_assist.$errors.length }"></div>
                          <label for="past_technical_assist">Have you received technical assistance in the past?<span
                              class="required">*</span></label>

                          <PrimeDropdown :invalid="v$.formData.past_technical_assist.$errors.length > 0"
                            id="past_technical_assist" class="w-full" v-model="formData.past_technical_assist"
                            :options="$menus.yesNoOptions" optionLabel="label" optionValue="value"
                            @blur="v$.formData.past_technical_assist.$touch()" placeholder="Select..." />



                          <div class="input-errors" v-for="error of v$.formData.past_technical_assist.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>

                        <div v-if="formData.past_technical_assist == 'Yes'" class="field col-12 md:col-6">
                          <div :class="{ error: v$.formData.past_technical_assist_desc.$errors.length }"></div>
                          <label for="past_technical_assist_desc">If yes, please describe: <span
                              class="required">*</span></label>
                          
                              <!-- <PrimeInputText :invalid="v$.formData.past_technical_assist_desc.$errors.length > 0"
                            v-model="formData.past_technical_assist_desc" class="w-full"
                            @blur="v$.formData.past_technical_assist_desc.$touch()" id="past_technical_assist_desc" /> -->

                            <TextArea :invalid="v$.formData.past_technical_assist_desc.$errors.length > 0" rows="1"
                                    v-model="formData.past_technical_assist_desc" class="w-full"
                                    @blur="v$.formData.past_technical_assist_desc.$touch()" id="past_technical_assist_desc"></TextArea>



                          <div class="input-errors" v-for="error of v$.formData.past_technical_assist_desc.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>






                      </div>

                    </template>
                    <template #footer>

                    </template>
                  </PrimeCard>
                </div>

                <!-- Other Information -->

                <div class="col-12 mt-4">
                  <PrimeCard class="">
                    <template #header>
                      <!-- <img alt="user header" src="/images/usercard.png" /> -->
                    </template>
                    <!-- <template #subtitle>Other Information </template> -->
                    <!-- <template #subtitle>Card subtitle</template> -->
                    <template #content>

                      <!-- <div class="flex gap-2 flex-wrap flex-column lg:flex-row "> -->
                      <div class="grid">
                        <div class="col-12">
                          <h4>4. Other Information</h4>
                        </div>
                        <div class="field col-12 md:col-6">
                          <div :class="{ error: v$.formData.registered_company.$errors.length }"></div>
                          <label for="registered_company">Are you registered with the Registrar of Companies? <span
                              class="required">*</span></label>

                          <PrimeDropdown :invalid="v$.formData.registered_company.$errors.length > 0"
                            id="registered_company" class="w-full" v-model="formData.registered_company"
                            :options="$menus.yesNoOptions" optionLabel="label" optionValue="value"
                            @blur="v$.formData.registered_company.$touch()" placeholder="Select..." />




                          <div class="input-errors" v-for="error of v$.formData.registered_company.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>

                        <div v-if="formData.registered_company == 'Yes'" class="field col-12 md:col-3">
                          <div :class="{ error: v$.formData.registration_year.$errors.length }"></div>
                          <label for="registration_year">Registration Year <span class="required">*</span></label>
                          <PrimeInputText :invalid="v$.formData.registration_year.$errors.length > 0"
                            v-model="formData.registration_year" class="w-full"
                            @blur="v$.formData.registration_year.$touch()" id="registration_year" />
                          <div class="input-errors" v-for="error of v$.formData.registration_year.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>

                        <div v-if="formData.registered_company == 'Yes'" class="field col-12 md:col-3">
                          <div :class="{ error: v$.formData.registration_id.$errors.length }"></div>
                          <label for="registration_id">Registration ID <span class="required">*</span></label>
                          <PrimeInputText :invalid="v$.formData.registration_id.$errors.length > 0"
                            v-model="formData.registration_id" class="w-full"
                            @blur="v$.formData.registration_id.$touch()" id="registration_id" />
                          <div class="input-errors" v-for="error of v$.formData.registration_id.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>

                        <div class="field col-12 md:col-6">
                          <div :class="{ error: v$.formData.gra.$errors.length }"></div>
                          <label for="gra">Are you registered with Ghana Revenue Authority <span
                              class="required">*</span></label>


                          <PrimeDropdown :invalid="v$.formData.gra.$errors.length > 0" id="gra" class="w-full"
                            v-model="formData.gra" :options="$menus.yesNoOptions" optionLabel="label"
                            optionValue="value" @blur="v$.formData.gra.$touch()" placeholder="Select..." />


                          <div class="input-errors" v-for="error of v$.formData.gra.$errors" :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>

                        <div v-if="formData.gra == 'Yes'" class="field col-12 md:col-6">
                          <div :class="{ error: v$.formData.gra_tin.$errors.length }"></div>
                          <label for="gra_tin">GRA TIN <span class="required">*</span></label>
                          <PrimeInputText :invalid="v$.formData.gra_tin.$errors.length > 0" v-model="formData.gra_tin"
                            class="w-full" @blur="v$.formData.gra_tin.$touch()" id="gra_tin" />
                          <div class="input-errors" v-for="error of v$.formData.gra_tin.$errors" :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>

                        <div class="field col-12 ">
                          <div :class="{ error: v$.formData.special_skills.$errors.length }"></div>
                          <label for="special_skills">Describe any training or skills development programs that you
                            offer to: (a) employees/contractors; or (b) community, outgrowers, customers, suppliers..
                            <span class="required">*</span></label>
                          <TextArea :invalid="v$.formData.special_skills.$errors.length > 0" rows="5"
                            v-model="formData.special_skills" class="w-full" @blur="v$.formData.special_skills.$touch()"
                            id="special_skills"></TextArea>

                          <div class="input-errors" v-for="error of v$.formData.special_skills.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>
                        <div class="field col-12 md:col-7">

                          <label for="how_know_us">How did you get to know about the Green Finance Facilitator Program?
                          </label>
                          <PrimeInputText v-model="formData.how_know_us" class="w-full" id="how_know_us" />
                          <!-- <div class="input-errors" v-for="error of v$.formData.how_know_us.$errors" :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div> -->
                        </div>

                        <div class="field col-12 md:col-5">
                          <!-- <div :class="{ error: v$.formData.referral_institution.$errors.length }"></div> -->
                          <label for="referral_institution">Referral Institution </label>
                          <PrimeInputText v-model="formData.referral_institution" class="w-full"
                            id="referral_institution" />
                          <!-- <div class="input-errors" v-for="error of v$.formData.referral_institution.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div> -->
                        </div>


                        <div class="field col-12 md:col-6">
                          <!-- <div :class="{ error: v$.formData.comments.$errors.length }"></div> -->
                          <label for="comments">Comments <span class="required">(please tell us anything else you would like us to know about
                            the project/activity you are hoping to finance or your past experience trying to access
                            finance)</span> </label>
                          <TextArea rows="5" v-model="formData.comments" class="w-full" id="comments"></TextArea>

                          <!-- <div class="input-errors" v-for="error of v$.formData.comments.$errors" :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div> -->
                        </div>




                      </div>

                    </template>
                    <template #footer>

                    </template>
                  </PrimeCard>
                </div>



                <div class="col-12 mt-4">
                  <PrimeCard class="">
                    <template #header>
                      <!-- <img alt="user header" src="/images/usercard.png" /> -->
                    </template>
                    <!-- <template #subtitle>Document Uploads</template> -->
                    <!-- <template #subtitle>Card subtitle</template> -->
                    <template #content>

                      <!-- <div class="flex gap-2 flex-wrap flex-column lg:flex-row "> -->
                      <div class="grid">
                        <div class="col-12">
                          <h4>5. Document Uploads</h4>
                          <p>Accepted formats: pdf, doc, docx, xls, xlsx, ppt, pptx, png, jpg, jpeg</p>
                          <p>File size limit: 10MB</p>
                        </div>
                        <div class="field col-12 md:col-6">
                          <div :class="{ error: v$.formData.business_certificate.$errors.length }"></div>

                          <label for="picture" class="form-label">Business Certificate <span
                              class="required">*</span></label>

                          <FileUpload v-model="formData.business_certificate" :show-cancel-button="false"
                            :show-upload-button="false" name="file" :url="endpoints.upload_business_certificate"
                            :multiple="false" :auto="true" accept=".pdf, .xlsx,.xls,.doc,.docx,.odt, image/*"
                            :maxFileSize="10485760" @upload="(event) => onUpload(event, 'business_certificate')">

                            <template #header="{ chooseCallback }">
                              <div class="flex flex-wrap justify-content-between align-items-center flex-1 gap-2">
                                <div class="flex gap-2">
                                  <PrimeButton @click="chooseCallback()" label="Select..." icon="pi pi-cloud-upload"
                                    rounded></PrimeButton>

                                </div>

                              </div>
                            </template>

                            <template
                              #content="{ files, uploadedFiles, removeUploadedFileCallback, removeFileCallback }">

                              <div v-if="files.length > 0">
                                <ProgressBar mode="indeterminate" style="height: 6px"></ProgressBar>

                                <div class="flex flex-wrap ">
                                  <div v-for="(file, index) of files" :key="file.name + file.type + file.size"
                                    class="m-0 flex flex-column surface-border align-items-center gap-1">
                                    <div>
                                      <!-- <img role="presentation" :alt="file.name" :src="file.objectURL" width="100"
                                        height="50" /> -->
                                    </div>
                                    <span class="font-semibold">Uploading {{ file.name }} ..</span>
                                    <div>{{ file.size }}</div>
                                    <Badge value="Pending" severity="warning" />
                                    <PrimeButton icon="pi pi-times"
                                      @click="onRemoveTemplatingFile(file, removeFileCallback, index)" outlined rounded
                                      severity="danger" />
                                  </div>
                                </div>
                              </div>

                              <div v-if="uploadedFiles.length > 0">

                                <div class="flex flex-wrap ">
                                  <div v-for="(file, index) of uploadedFiles" :key="file.name + file.type + file.size"
                                    class="">
                                    <!-- <div>
                                <img role="presentation" :alt="file.name" :src="file.objectURL" width="100" height="50" />
                            </div> -->
                                    <span class="font-semibold">{{ file.name }}</span>
                                    <div>{{ formatSize(file.size) }}</div>
                                    <Badge value="Completed" class="mt-3" severity="success" />
                                    <PrimeButton icon="pi pi-times" @click="removeUploadedFileCallback(index)" outlined
                                      rounded severity="danger" />
                                  </div>
                                </div>
                              </div>



                            </template>

                          </FileUpload>
                          <a style="color: teal;" v-if="formData.business_certificate"
                            :href="apiBase + formData.business_certificate" target="_blank"><i class="pi pi-paperclip"
                              style="font-size: 1rem"> </i>Business
                            certificate</a>
                          <div class="input-errors" v-for="error of v$.formData.business_certificate.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>

                        <div class="field col-12 md:col-6">
                          <div :class="{ error: v$.formData.financial_statement1.$errors.length }"></div>

                          <label for="picture" class="form-label">Financial Statement Year 1 <span
                              class="required">*</span></label>

                          <FileUpload v-model="formData.financial_statement1" :show-cancel-button="false"
                            :show-upload-button="false" name="file" :url="endpoints.upload_financial_statement1"
                            :multiple="false" :auto="true" accept=".pdf, .xlsx,.xls,.doc,.docx,.odt, image/*"
                            :maxFileSize="10485760" @upload="(event) => onUpload(event, 'financial_statement1')">

                            <template #header="{ chooseCallback }">
                              <div class="flex flex-wrap justify-content-between align-items-center flex-1 gap-2">
                                <div class="flex gap-2">
                                  <PrimeButton @click="chooseCallback()" label="Select..." icon="pi pi-cloud-upload"
                                    rounded></PrimeButton>

                                </div>

                              </div>
                            </template>

                            <template
                              #content="{ files, uploadedFiles, removeUploadedFileCallback, removeFileCallback }">

                              <div v-if="files.length > 0">
                                <ProgressBar mode="indeterminate" style="height: 6px"></ProgressBar>

                                <div class="flex flex-wrap ">
                                  <div v-for="(file, index) of files" :key="file.name + file.type + file.size"
                                    class="m-0 flex flex-column surface-border align-items-center gap-1">
                                    <div>
                                      <!-- <img role="presentation" :alt="file.name" :src="file.objectURL" width="100"
                                        height="50" /> -->
                                    </div>
                                    <span class="font-semibold">Uploading {{ file.name }} ..</span>
                                    <div>{{ file.size }}</div>
                                    <Badge value="Pending" severity="warning" />
                                    <PrimeButton icon="pi pi-times"
                                      @click="onRemoveTemplatingFile(file, removeFileCallback, index)" outlined rounded
                                      severity="danger" />
                                  </div>
                                </div>
                              </div>

                              <div v-if="uploadedFiles.length > 0">

                                <div class="flex flex-wrap ">
                                  <div v-for="(file, index) of uploadedFiles" :key="file.name + file.type + file.size"
                                    class="">
                                    <!-- <div>
                                <img role="presentation" :alt="file.name" :src="file.objectURL" width="100" height="50" />
                            </div> -->
                                    <span class="font-semibold">{{ file.name }}</span>
                                    <div>{{ formatSize(file.size) }}</div>
                                    <Badge value="Completed" class="mt-3" severity="success" />
                                    <PrimeButton icon="pi pi-times" @click="removeUploadedFileCallback(index)" outlined
                                      rounded severity="danger" />
                                  </div>
                                </div>
                              </div>



                            </template>

                          </FileUpload>
                          <a style="color: teal;" v-if="formData.financial_statement1"
                            :href="apiBase + formData.financial_statement1" target="_blank"><i class="pi pi-paperclip"
                              style="font-size: 1rem"> </i>Financial Statement
                            Year
                            1</a>
                          <div class="input-errors" v-for="error of v$.formData.financial_statement1.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>

                        <div class="field col-12 md:col-6">
                          <div :class="{ error: v$.formData.financial_statement2.$errors.length }"></div>

                          <label for="picture" class="form-label">Financial Statement Year 2 <span
                              class="required">*</span></label>

                          <FileUpload v-model="formData.financial_statement2" :show-cancel-button="false"
                            :show-upload-button="false" name="file" :url="endpoints.upload_financial_statement2"
                            :multiple="false" :auto="true" accept=".pdf, .xlsx,.xls,.doc,.docx,.odt, image/*"
                            :maxFileSize="10485760" @upload="(event) => onUpload(event, 'financial_statement2')">

                            <template #header="{ chooseCallback }">
                              <div class="flex flex-wrap justify-content-between align-items-center flex-1 gap-2">
                                <div class="flex gap-2">
                                  <PrimeButton @click="chooseCallback()" label="Select..." icon="pi pi-cloud-upload"
                                    rounded></PrimeButton>

                                </div>

                              </div>
                            </template>

                            <template
                              #content="{ files, uploadedFiles, removeUploadedFileCallback, removeFileCallback }">

                              <div v-if="files.length > 0">
                                <ProgressBar mode="indeterminate" style="height: 6px"></ProgressBar>

                                <div class="flex flex-wrap ">
                                  <div v-for="(file, index) of files" :key="file.name + file.type + file.size"
                                    class="m-0 flex flex-column surface-border align-items-center gap-1">
                                    <div>
                                      <!-- <img role="presentation" :alt="file.name" :src="file.objectURL" width="100"
                                        height="50" /> -->
                                    </div>
                                    <span class="font-semibold">Uploading {{ file.name }} ..</span>
                                    <div>{{ file.size }}</div>
                                    <Badge value="Pending" severity="warning" />
                                    <PrimeButton icon="pi pi-times"
                                      @click="onRemoveTemplatingFile(file, removeFileCallback, index)" outlined rounded
                                      severity="danger" />
                                  </div>
                                </div>
                              </div>

                              <div v-if="uploadedFiles.length > 0">

                                <div class="flex flex-wrap ">
                                  <div v-for="(file, index) of uploadedFiles" :key="file.name + file.type + file.size"
                                    class="">
                                    <!-- <div>
                                <img role="presentation" :alt="file.name" :src="file.objectURL" width="100" height="50" />
                            </div> -->
                                    <span class="font-semibold">{{ file.name }}</span>
                                    <div>{{ formatSize(file.size) }}</div>
                                    <Badge value="Completed" class="mt-3" severity="success" />
                                    <PrimeButton icon="pi pi-times" @click="removeUploadedFileCallback(index)" outlined
                                      rounded severity="danger" />
                                  </div>
                                </div>
                              </div>



                            </template>
                          </FileUpload>
                          <a style="color: teal;" v-if="formData.financial_statement2"
                            :href="apiBase + formData.financial_statement2" target="_blank"><i class="pi pi-paperclip"
                              style="font-size: 1rem"> </i>Financial Statement
                            Year
                            2</a>
                          <div class="input-errors" v-for="error of v$.formData.financial_statement2.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>

                        <div class="field col-12 md:col-6">
                          <div :class="{ error: v$.formData.financial_statement3.$errors.length }"></div>

                          <label for="picture" class="form-label">Financial Statement Year 3 <span
                              class="required">*</span></label>

                          <FileUpload v-model="formData.financial_statement3" :show-cancel-button="false"
                            :show-upload-button="false" name="file" :url="endpoints.upload_financial_statement3"
                            :multiple="false" :auto="true" accept=".pdf, .xlsx,.xls,.doc,.docx,.odt, image/*"
                            :maxFileSize="10485760" @upload="(event) => onUpload(event, 'financial_statement3')">

                            <template #header="{ chooseCallback }">
                              <div class="flex flex-wrap justify-content-between align-items-center flex-1 gap-2">
                                <div class="flex gap-2">
                                  <PrimeButton @click="chooseCallback()" label="Select" icon="pi pi-cloud-upload"
                                    rounded></PrimeButton>

                                </div>

                              </div>
                            </template>

                            <template
                              #content="{ files, uploadedFiles, removeUploadedFileCallback, removeFileCallback }">

                              <div v-if="files.length > 0">
                                <ProgressBar mode="indeterminate" style="height: 6px"></ProgressBar>

                                <div class="flex flex-wrap ">
                                  <div v-for="(file, index) of files" :key="file.name + file.type + file.size"
                                    class="m-0 flex flex-column surface-border align-items-center gap-1">
                                    <div>
                                      <!-- <img role="presentation" :alt="file.name" :src="file.objectURL" width="100"
                                        height="50" /> -->
                                    </div>
                                    <span class="font-semibold">Uploading {{ file.name }} ..</span>
                                    <div>{{ file.size }}</div>
                                    <Badge value="Pending" severity="warning" />
                                    <PrimeButton icon="pi pi-times"
                                      @click="onRemoveTemplatingFile(file, removeFileCallback, index)" outlined rounded
                                      severity="danger" />
                                  </div>
                                </div>
                              </div>

                              <div v-if="uploadedFiles.length > 0">

                                <div class="flex flex-wrap ">
                                  <div v-for="(file, index) of uploadedFiles" :key="file.name + file.type + file.size"
                                    class="">
                                    <!-- <div>
                                <img role="presentation" :alt="file.name" :src="file.objectURL" width="100" height="50" />
                            </div> -->
                                    <span class="font-semibold">{{ file.name }}</span>
                                    <div>{{ formatSize(file.size) }}</div>
                                    <Badge value="Completed" class="mt-3" severity="success" />
                                    <PrimeButton icon="pi pi-times" @click="removeUploadedFileCallback(index)" outlined
                                      rounded severity="danger" />
                                  </div>
                                </div>
                              </div>



                            </template>


                          </FileUpload>
                          <a style="color: teal;" v-if="formData.financial_statement3"
                            :href="apiBase + formData.financial_statement3" target="_blank"><i
                              class="pi pi-paperclip mr-1" style="font-size: 1rem"> </i>Finacial Statement
                            Year
                            3</a>
                          <div class="input-errors" v-for="error of v$.formData.financial_statement3.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>



                        <div class="field col-12 md:col-6">
                          <div :class="{ error: v$.formData.business_plan.$errors.length }"></div>

                          <label for="picture" class="form-label">Business Plan<span class="required">*</span></label>


                          <FileUpload :show-cancel-button="false" :show-upload-button="false" name="file[]"
                            :url="endpoints.upload_business_plan" :multiple="false" :auto="true"
                            accept=".pdf, .xlsx,.xls,.doc,.docx,.odt, image/*" :maxFileSize="10485760"
                            @upload="(event) => onUpload(event, 'business_plan')">

                            <template #header="{ chooseCallback }">
                              <div class="flex flex-wrap justify-content-between align-items-center flex-1 gap-2">
                                <div class="flex gap-2">
                                  <PrimeButton @click="chooseCallback()" label="Select..." icon="pi pi-cloud-upload"
                                    rounded></PrimeButton>

                                </div>

                              </div>
                            </template>

                            <template
                              #content="{ files, uploadedFiles, removeUploadedFileCallback, removeFileCallback }">

                              <div v-if="files.length > 0">
                                <ProgressBar mode="indeterminate" style="height: 6px"></ProgressBar>

                                <div class="flex flex-wrap ">
                                  <div v-for="(file, index) of files" :key="file.name + file.type + file.size"
                                    class="m-0 flex flex-column surface-border align-items-center gap-1">
                                    <div>
                                      <!-- <img role="presentation" :alt="file.name" :src="file.objectURL" width="100"
                                        height="50" /> -->
                                    </div>
                                    <span class="font-semibold">Uploading {{ file.name }} ..</span>
                                    <div>{{ file.size }}</div>
                                    <Badge value="Pending" severity="warning" />
                                    <PrimeButton icon="pi pi-times"
                                      @click="onRemoveTemplatingFile(file, removeFileCallback, index)" outlined rounded
                                      severity="danger" />
                                  </div>
                                </div>
                              </div>

                              <div v-if="uploadedFiles.length > 0">

                                <div class="flex flex-wrap ">
                                  <div v-for="(file, index) of uploadedFiles" :key="file.name + file.type + file.size"
                                    class="">
                                    <!-- <div>
                                <img role="presentation" :alt="file.name" :src="file.objectURL" width="100" height="50" />
                            </div> -->
                                    <span class="font-semibold">{{ file.name }}</span>
                                    <div>{{ formatSize(file.size) }}</div>
                                    <Badge value="Completed" class="mt-3" severity="success" />
                                    <PrimeButton icon="pi pi-times" @click="removeUploadedFileCallback(index)" outlined
                                      rounded severity="danger" />
                                  </div>
                                </div>
                              </div>



                            </template>

                          </FileUpload>

                          <a style="color: teal;" v-if="formData.business_plan" :href="apiBase + formData.business_plan"
                            target="_blank"><i class="pi pi-paperclip mr-1" style="font-size: 1rem"> </i>Business
                            Plan</a>

                          <div class="input-errors" v-for="error of v$.formData.business_plan.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>


                        <div class="field col-12 md:col-6">
                          <div :class="{ error: v$.formData.financial_projections.$errors.length }"></div>

                          <label for="picture" class="form-label">Financial Projections<span
                              class="required">*</span></label>


                          <FileUpload :show-cancel-button="false" v-model="formData.financial_projections"
                            :show-upload-button="false" name="file" :url="endpoints.upload_financial_projections"
                            :multiple="false" :auto="true" accept=".pdf, .xlsx,.xls,.doc,.docx,.odt, image/*"
                            :maxFileSize="10485760" @upload="(event) => onUpload(event, 'financial_projections')">

                            <template #header="{ chooseCallback }">
                              <div class="flex flex-wrap justify-content-between align-items-center flex-1 gap-2">
                                <div class="flex gap-2">
                                  <PrimeButton @click="chooseCallback()" label="Select..." icon="pi pi-cloud-upload"
                                    rounded></PrimeButton>

                                </div>

                              </div>
                            </template>

                            <template
                              #content="{ files, uploadedFiles, removeUploadedFileCallback, removeFileCallback }">

                              <div v-if="files.length > 0">
                                <ProgressBar mode="indeterminate" style="height: 6px"></ProgressBar>

                                <div class="flex flex-wrap ">
                                  <div v-for="(file, index) of files" :key="file.name + file.type + file.size"
                                    class="m-0 flex flex-column surface-border align-items-center gap-1">
                                    <div>
                                      <!-- <img role="presentation" :alt="file.name" :src="file.objectURL" width="100"
                                        height="50" /> -->
                                    </div>
                                    <span class="font-semibold">Uploading {{ file.name }} ..</span>
                                    <div>{{ file.size }}</div>
                                    <Badge value="Pending" severity="warning" />
                                    <PrimeButton icon="pi pi-times"
                                      @click="onRemoveTemplatingFile(file, removeFileCallback, index)" outlined rounded
                                      severity="danger" />
                                  </div>
                                </div>
                              </div>

                              <div v-if="uploadedFiles.length > 0">

                                <div class="flex flex-wrap ">
                                  <div v-for="(file, index) of uploadedFiles" :key="file.name + file.type + file.size"
                                    class="">
                                    <!-- <div>
                                <img role="presentation" :alt="file.name" :src="file.objectURL" width="100" height="50" />
                            </div> -->
                                    <span class="font-semibold">{{ file.name }}</span>
                                    <div>{{ formatSize(file.size) }}</div>
                                    <Badge value="Completed" class="mt-3" severity="success" />
                                    <PrimeButton icon="pi pi-times" @click="removeUploadedFileCallback(index)" outlined
                                      rounded severity="danger" />
                                  </div>
                                </div>
                              </div>



                            </template>
                          </FileUpload>

                          <a style="color: teal;" v-if="formData.financial_projections"
                            :href="apiBase + formData.financial_projections" target="_blank"><i
                              class="pi pi-paperclip mr-1" style="font-size: 1rem"> </i>Financial
                            Projections</a>

                          <div class="input-errors" v-for="error of v$.formData.financial_projections.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>


                        <div class="field col-12 md:col-6">
                          <div :class="{ error: v$.formData.letter_of_interest.$errors.length }"></div>

                          <label for="picture" class="form-label">Letter of Interest<span
                              class="required">*</span></label>


                          <FileUpload :show-cancel-button="false" v-model="formData.letter_of_interest"
                            :show-upload-button="false" name="file" :url="endpoints.upload_letter_of_interest"
                            :multiple="false" :auto="true" accept=".pdf, .xlsx,.xls,.doc,.docx,.odt, image/*"
                            :maxFileSize="10485760" @upload="(event) => onUpload(event, 'letter_of_interest')">

                            <template #header="{ chooseCallback }">
                              <div class="flex flex-wrap justify-content-between align-items-center flex-1 gap-2">
                                <div class="flex gap-2">
                                  <PrimeButton @click="chooseCallback()" label="Select..." icon="pi pi-cloud-upload"
                                    rounded></PrimeButton>

                                </div>

                              </div>
                            </template>

                            <template
                              #content="{ files, uploadedFiles, removeUploadedFileCallback, removeFileCallback }">

                              <div v-if="files.length > 0">
                                <ProgressBar mode="indeterminate" style="height: 6px"></ProgressBar>

                                <div class="flex flex-wrap ">
                                  <div v-for="(file, index) of files" :key="file.name + file.type + file.size"
                                    class="m-0 flex flex-column surface-border align-items-center gap-1">
                                    <div>
                                      <!-- <img role="presentation" :alt="file.name" :src="file.objectURL" width="100"
                                        height="50" /> -->
                                    </div>
                                    <span class="font-semibold">Uploading {{ file.name }} ..</span>
                                    <div>{{ file.size }}</div>
                                    <Badge value="Pending" severity="warning" />
                                    <PrimeButton icon="pi pi-times"
                                      @click="onRemoveTemplatingFile(file, removeFileCallback, index)" outlined rounded
                                      severity="danger" />
                                  </div>
                                </div>
                              </div>

                              <div v-if="uploadedFiles.length > 0">

                                <div class="flex flex-wrap ">
                                  <div v-for="(file, index) of uploadedFiles" :key="file.name + file.type + file.size"
                                    class="">
                                    <!-- <div>
                                <img role="presentation" :alt="file.name" :src="file.objectURL" width="100" height="50" />
                            </div> -->
                                    <span class="font-semibold">{{ file.name }}</span>
                                    <div>{{ formatSize(file.size) }}</div>
                                    <Badge value="Completed" class="mt-3" severity="success" />
                                    <PrimeButton icon="pi pi-times" @click="removeUploadedFileCallback(index)" outlined
                                      rounded severity="danger" />
                                  </div>
                                </div>
                              </div>


                            </template>
                          </FileUpload>

                          <a style="color: teal;" v-if="formData.letter_of_interest"
                            :href="apiBase + formData.letter_of_interest" target="_blank"><i
                              class="pi pi-paperclip mr-1" style="font-size: 1rem"> </i>Letter of
                            Interest</a>

                          <div class="input-errors" v-for="error of v$.formData.letter_of_interest.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>


                        <div class="col-12">
                          <h4>Optional Documents</h4>

                          <h5>Upload any additional documents not specified above</h5>
                          <hr>
                          <ProgressBar v-if="other_uploading" mode="indeterminate" style="height: 6px"></ProgressBar>

                          <!-- <ul>
                            <li v-for="(doc, id) in other_docs" v-bind:key="id"> <a
                                :href="apiBase + doc.url">{{ doc.name }}</a> </li>
                          </ul> -->

                          <!-- <p v-for="(doc, id) in other_docs" v-bind:key="id"> <a :href="apiBase+doc.url">{{doc.name}}</a>  </p> -->
                        </div>

                        <div class="col-12 mt-2">
                          <div v-for="(doc, id) in other_docs" v-bind:key="id" class="flex gap-5">

                            <div>
                              <i class="pi pi-paperclip mr-1" style="font-size: 1rem; color:green"></i>
                              <a style="color: teal;" :href="apiBase + doc.url">{{ doc.name }}</a>
                            </div>

                            <div class="field col-5">
                              <i class="pi pi-trash" style="font-size: 1rem; color:red" @click="removeOtherDoc(id)"></i>
                            </div>
                          </div>
                        </div>



                        <div class="grid align-items-end mt-2">


                          <div class="field col-6">

                            <label for="other_doc_name">Document Category</label>
                            <!-- <PrimeInputText v-model="other_doc_name" class="w-full" id="other_doc_name" /> -->
                            <PrimeDropdown :invalid="v$.formData.nationality.$errors.length > 0" id="business_type"
                              class="w-full" v-model="other_doc_name" :options="$menus.document_options"
                              optionLabel="label" optionValue="value" placeholder="Select Category" />


                          </div>

                          <div v-if="other_doc_name == 'Other'" class="field col-6">
                            <label for="username">Specify Other</label>
                            <PrimeInputText v-model="other_doc_name_specify" class="w-full" id="other_doc_name" />
                          </div>

                          <div class="field col-3">

                            <FileUpload mode="basic" name="file" :url="endpoints.upload_financial_projections"
                              :accept="acceptedFormats" :maxFileSize="10485760"
                              @upload="(event) => onOtherUpload(event)" :auto="true" @select="onOtherUploadSelected"
                              chooseLabel="Select..." :disabled="other_doc_name == ''" @click="checkEmptyDocName" />

                          </div>


                        </div>



                      </div>

                    </template>
                    <template #footer>

                    </template>
                  </PrimeCard>
                </div>


              </div>


              <div class="form-buttons flex justify-content-start">

                <span>

                  <PrimeButton style="font-size: 1.1rem" type="button" label="Save Progress" :loading="saving"
                    severity="warning" icon="pi pi-save" @click="autoSave" />

                  <!-- <PrimeButton style="font-size: 1.1rem" v-else type="button" label="Save Progress" :loading="saving"
                    severity="warning" icon="pi pi-save" @click="saveProgress" /> -->


                </span>

                <span class="ml-3">
                  <PrimeButton style="font-size: 1.1rem" type="submit" :loading="loading" label="Submit"
                    severity="success" icon="pi pi-send" />
                </span>

              </div>

              <!-- <p>By clicking the submit button, I agree to <a target="_blank"
          href="https://newsite.gff.com">terms
          and conditions</a> </p>
      <div class="flex flex-wrap gap-3">
        <div class="flex ">
          <PrimeRadioButton v-model="formData.terms_and_conditions" inputId="terms1" name="terms" value="Yes" />
          <label for="ingredient2" class="ml-2">I Accept</label>
        </div>
        <div class="flex ">
          <PrimeRadioButton checked v-model="formData.terms_and_conditions" inputId="terms2" name="terms"
            value="No" />
          <label for="ingredient3" class="ml-2">I do not Accept</label>
        </div>
      </div>


      <div class="form-buttons">
        <PrimeButton type="button" label="Back" icon="pi pi-chevron-left" @click="prevStep"
          class="p-button-secondary" />
        <PrimeButton :disabled="!isAccepted" type="submit" :loading="loading" label="Submit" icon="pi pi-check" />
      </div> -->


            </div>



          </form>
        </div>


      </div>




    </div>
  </div>


</template>


<script>
/* eslint-disable */
import { useConfirm } from "primevue/useconfirm";
import { useToast } from 'primevue/usetoast';
import { ConfirmDialog } from 'primevue/confirmdialog';
import { useVuelidate } from '@vuelidate/core'
import { required, requiredIf, email, helpers, nullable, between } from '@vuelidate/validators'
import axios from 'axios';
import { debounce } from 'lodash';

// const confirm = useConfirm();


const baseUrl = "http://localhost/nessa";
//const baseUrl = "https://gffapi.greenfinancefacilitator.com";
//const baseUrl = "https://gffapi.apps4solutions.com";
const phoneCheck = helpers.regex(/^0[2-5]\d{8}$/);
const endpoints = {
  apply: baseUrl + "/api/applications/apply", //submit
  save: baseUrl + "/api/applications/saveprogress",
  sendtoken: baseUrl + "/customers/sendtoken",
  retrieve: baseUrl + "/api/applications/retrieve",
  update: baseUrl + "/api/applications/update",
  autosave: baseUrl + "/api/applications/autosave",
  checkemailexists: baseUrl + "/api/components_data/applications_email_exist/"



}

export default {
  setup() {
    return { v$: useVuelidate() }
  },
  props: ['params'],
  data() {
    return {
      apiBase: 'http://localhost/nessa/',
      // apiBase: 'https://gffapi.greenfinancefacilitator.com/',
      //apiBase: 'https://gffapi.apps4solutions.com/',
      start: false,
      resume: false, // activates resume panel
      main: false,
      visible: true,
      is_update: false,//set if form is retrieve. If current operation is an update
      retrieval_email: '',//email which the token is sent to
      token_received: false,//true if token is received
      token: '', // token value
      sending_token: false,
      showRetryDialog: false,
      showEmailDuplicateDialog: false,
      totalSize: 0,
      totalSizePercent: 0,
      autosaving: false,
      old_email: '',
      loading: false,
      saving: false,
      buttonText: "Verify",
      buttonDisable: true,
      showSuccessDialog: false,
      showCompleteDialog: false,
      showErrorDialog: false,
      uploadProgress: 0,
      countDown: '00:00',
      tokenExpired: '',
      canResendToken: false,
      filePath: '',

      endpoints: {
        upload_business_certificate: baseUrl + "/api/fileuploader/upload/business_certificate",
        upload_business_plan: baseUrl + "/api/fileuploader/upload/business_plan",
        upload_financial_projections: baseUrl + "/api/fileuploader/upload/financial_projections",
        upload_financial_statement1: baseUrl + "/api/fileuploader/upload/financial_statement1",
        upload_financial_statement2: baseUrl + "/api/fileuploader/upload/financial_statement2",
        upload_financial_statement3: baseUrl + "/api/fileuploader/upload/financial_statement3",
        upload_letter_of_interest: baseUrl + "/api/fileuploader/upload/letter_of_interest",



      },
      formPDFLink: "https://greenfinancefacilitator.com/documents/The_GFF_Application_Form.pdf",
      formExcelLink: "https://greenfinancefacilitator.com/documents/The_GFF_Application_Form.xlsx",

      formData: {
        application_id: '',
        lastname: '',
        firstname: '',
        othernames: '',
        nationality: 'Ghana',
        email: '',
        street_address: '',
        city: '',
        region: '',
        mobile: '',
        home_phone: '',
        business_name: '',
        business_address: '',
        business_description: '',
        business_digital_address: '',
        business_website: '',
        socialmedia_handles: '',
        business_type: '',
        male_staff: '',
        female_staff: '',
        expected_staff_size: '',
        sales_revenue_2021: '',
        sales_revenue_2022: '',
        sales_revenue_2023: '',
        ebitda_2021: '',
        ebitda_2022: '',
        ebitda_2023: '',
        debt: 0,
        equity: 0,
        registered_company: '',
        registration_year: '',
        registration_id: '',
        gra: '',
        gra_tin: '',
        funding_beneficiary: '',
        funder: '',
        audited_business: '',
        auditor_name: '',
        sector: '',
        other_sector: '',
        owners: '',
        special_skills: '',
        how_know_us: '',
        referral_institution: '',
        comments: '',
        business_certificate: '',
        financial_statement1: '',
        financial_statement2: '',
        financial_statement3: '',
        business_plan: '',
        financial_projections: '',
        letter_of_interest: '',
        other_documents: '',
        submitted: '',
        fulltime_staff: '', //phase 2 modification starts here
        parttime_staff: '',
        sector_json: '',
        sector_code: '',
        subsector: '',
        subsector_json: '',
        subsector_code: '',
        finance_currency: '',
        grantt: '', // grant is a reserved db word so I used grantt
        finance_purpose: '',
        outstanding_grant: '',
        grant_description: '',
        past_technical_assist: '',
        past_technical_assist_desc: ''

      },

      sectorOptions: [
        {
          name: "Renewable Energy",
          code: "REN",
          subsectors: [
            {
              name: "Solar Energy Generation, Transmission & Materials (e.g., solar panel manufacturing)",
              code: "SOL"
            },
            {
              name: "Wind Energy Generation, Transmission, Materials (e.g., turbine manufacturing)",
              code: "WIN"
            },
            {
              name: "Hydro Power and related infrastructure",
              code: "HYD"
            },
            {
              name: "Biofuels and other clean energy sources",
              code: "BIO"
            },
            {
              name: "Energy storage technologies & services",
              code: "STO"
            },
            {
              name: "Other",
              code: ""
            }
          ]
        },
        {
          name: "Energy Efficiency",
          code: "EFE",
          subsectors: [
            {
              name: "Installation of renewable energy to support business operations",
              code: "INS"
            },
            {
              name: "Energy efficient technologies and manufacturing of energy efficient appliances",
              code: "ETC"
            },
            {
              name: "Upgrading of plant and equipment for improved energy efficiency",
              code: "EUP"
            },
            {
              name: "Installation of energy metering and control technologies",
              code: "EMC"
            },
            {
              name: "Other",
              code: ""
            }
          ]
        },
        {
          name: "Agriculture including Forestry, Aquaculture and Blue Economy",
          code: "AGA",
          subsectors: [
            {
              name: "Sustainable Agriculture – Fruits & Vegetables",
              code: "FRV"
            },
            {
              name: "Sustainable Agriculture – Animals & Livestock",
              code: "ANL"
            },
            {
              name: "Sustainable Agriculture – Improved resource use processes & practices related to water, energy, fertilizers, pesticides etc.",
              code: "SUP"
            },
            {
              name: "Forestry & Forest Management",
              code: "FOR"
            },
            {
              name: "Agribusiness – pre or post harvest inputs (such as organic fertilizer, non-toxic pesticides) and services",
              code: "AGB"
            },
            {
              name: "Aquaculture – fisheries, algae production etc",
              code: "AQU"
            },
            {
              name: "Blue Economy -cultivating, processing & sales",
              code: "BLU"
            },
            {
              name: "Other",
              code: ""
            }
          ]
        },
        {
          name: "Sustainable Water and Wastewater Management",
          code: "WWM",
          subsectors: [
            {
              name: "Sustainable Water Use projects and systems (non-agriculture related)",
              code: "SWU"
            },
            {
              name: "Waste Water Treatment and Management",
              code: "WWT"
            },
            {
              name: "Solid Waste Treatment and Management",
              code: "SWT"
            },
            {
              name: "Sustainable water and waste technologies and solutions",
              code: "SWS"
            },
            {
              name: "Sustainable packaging, recycling facilities and services, upcycling of textile or other waste",
              code: "SPR"
            },
            {
              name: "Other",
              code: ""
            }
          ]
        },
        {
          name: "Sustainable Transportation",
          code: "STA",
          subsectors: [
            {
              name: "Electric vehicles and mobility solutions",
              code: "EVM"
            },
            {
              name: "Transportation services using EVM",
              code: "STS"
            },
            {
              name: "Sustainable transportation infrastructure and services",
              code: "STI"
            },
            {
              name: "Other clean and sustainable transport solutions and technologies",
              code: "OST"
            },
            {
              name: "Other",
              code: ""
            }
          ]
        },
        {
          name: "Climate Change Adaptation",
          code: "CCA",
          subsectors: [
            {
              name: "Data collection and monitoring technology ",
              code: "DCM"
            },
            {
              name: "Carbon credits and trading",
              code: "CCT"
            },
            {
              name: "Analysis and packaging of weather-related data",
              code: "APW"
            },
            {
              name: "Other adaptation solutions",
              code: "OAS"
            },
            {
              name: "Other",
              code: ""
            }
          ]
        },
        {
          name: "Green Buildings and Construction",
          code: "GBC",
          subsectors: [
            {
              name: "Green roofs and green roofing services",
              code: "GRF"
            },
            {
              name: "Green retrofitting of commercial or residential buildings",
              code: "RET"
            },
            {
              name: "New green construction commercial or residential buildings",
              code: "NGC"
            },
            {
              name: "Production of green building materials, including sustainable insulation",
              code: "GBM"
            },
            {
              name: "Other",
              code: ""
            }
          ]
        },

      ],

      subsectorOptions: [],

      selectedSector: "",
      selectedSubsector: "",

      ownership: [
        {
          name: '',
          percentage: '',
          role: '',
          gender: '',
        },

      ],
      other_docs: [

      ],
      other_doc_name: '',
      other_doc_name_specify: '',
      other_uploading: false,
      acceptedFormats: '.pdf, .xlsx,.xls,.doc,.docx,.odt,.ppt,.pptx image/*',

      social_media_platforms: [
        {
          platform: '',
          handle: ''

        },

      ],

      platformOptions: [
        { label: 'Facebook', value: 'Facebook' },
        { label: 'Twitter', value: 'Twitter' },
        { label: 'Instagram', value: 'Instagram' },
        { label: 'LinkedIn', value: 'LinkedIn' },
        { label: 'Youtube', value: 'Youtube' },

      ],


      errorMessage: '',
      successMessage: '',
      verifyLaterMessage: 'It seems you are having trouble verifying your identity. You would like to verify it later?',


    };
  },
  validations() {
    const startsWithZero = (value) => /^0\d+$/.test(value);
    return {
      formData: {

        lastname: { required },
        firstname: { required },
        othernames: {},
        nationality: { required },
        email: { required, email },
        street_address: { required },
        city: { required },
        region: { required },
        mobile: { required, startsWithZero },
        // home_phone:{startsWithZero},
        home_phone: {
          $nullable: (val) => {
            // Adjust the validation criteria as needed
            return val === '' ||
              val == null ||
              startsWithZero(val);
          }
        },
        business_name: { required },
        business_address: { required },
        business_description: { required },
        business_digital_address: { required },
        business_website: { required },
        business_type: { required },

        male_staff: { required },
        female_staff: { required },
        expected_staff_size: { required },
        sales_revenue_2021: { required },
        sales_revenue_2022: { required },
        sales_revenue_2023: { required },
        ebitda_2021: { required },
        ebitda_2022: { required },
        ebitda_2023: { required },
        debt: { required },
        equity: { required },
        registered_company: { required },
        registration_year: { requiredIf: requiredIf(() => this.formData.registered_company === 'Yes') },
        registration_id: { requiredIf: requiredIf(() => this.formData.registered_company === 'Yes') },
        gra: { required },
        gra_tin: { requiredIf: requiredIf(() => this.formData.gra === 'Yes') },
        funding_beneficiary: { required },
        funder: { requiredIf: requiredIf(() => this.formData.funding_beneficiary === 'Yes') },
        audited_business: { required },
        auditor_name: { requiredIf: requiredIf(() => this.formData.audited_business === 'Yes') },
        sector: { required },
        other_sector: { requiredIf: requiredIf(() => this.formData.sector === 'Other') },
        special_skills: { required },
        business_certificate: { required },
        financial_statement1: { required },
        financial_statement2: { required },
        financial_statement3: { required },
        business_plan: { required },
        financial_projections: { required },
        letter_of_interest: { required },
        fulltime_staff: { required },
        parttime_staff: { required },
        sector_json: { required },
        sector_code: { required },
        subsector_code: { required },
        subsector: { required },
        subsector_json: { required },
        finance_currency: { required },
        grantt: { required },
        finance_purpose: { required },
        outstanding_grant: { required },
        grant_description: { requiredIf: requiredIf(() => this.formData.outstanding_grant === 'Yes') },
        past_technical_assist: { required },
        past_technical_assist_desc: { requiredIf: requiredIf(() => this.formData.past_technical_assist === 'Yes') },

      },


    }
  },
  computed: {
    isAccepted() {
      return this.formData.terms_and_conditions === 'Yes';
    },
    isNationalID() {
      return this.formData.identification_type === 'National ID';

    },
    isForeigner() {
      return this.formData.identification_type === 'Passport';

    },

    calculateMaxDate() {
      const today = new Date();
      const year = today.getFullYear() - 18;
      const month = today.getMonth();
      const day = today.getDate();
      return new Date(year, month, day);
    }
  },
  mounted() {
    // Access the route param when the component mounts
    this.param = this.$route.params.params;
    //console.log('Route param on mount:', this.params);
    if (this.params == 'start') {
      this.main = true
    } else {
      this.resume = true
    }

    // this.autoSaveInterval = setInterval(() => {
    //   this.autoSave();
    // }, 45000);
  },

  beforeDestroy() {
    // Clear the interval when the component is destroyed
    if (this.autoSaveInterval) {
      clearInterval(this.autoSaveInterval);
    }
  },
  methods: {



    async handleSubmit() {
      // console.log(this.formData)
      this.v$.$touch();
      const result = await this.v$.$validate()

      // const invalidFields = [];

      // // Check each field for $invalid
      // for (const field in this.v$.formData) {
      //   if (this.v$.formData[field].$invalid) {
      //     invalidFields.push(field);
      //   }
      // }
      // console.log(invalidFields);
      // console.log(result);
      if (!result) {
        // notify user form is invalid
        // alert('All fields marked * are mandatory');

        //window.scrollTo({ top: 250, behavior: 'smooth' });

        this.$toast.add({ severity: 'error', summary: 'Info', detail: 'Some fields are missing or incorrect. Please fix them to proceed', life: 6000 });


      } else {
        this.loading = true;
        try {
          this.formData.owners = JSON.stringify(this.ownership)
          this.formData.other_documents = JSON.stringify(this.other_docs)
          const response = await axios.post(endpoints.apply, this.formData);


          if (response.data.code == "00") {

            this.$toast.add({ severity: 'success', summary: 'Info', detail: 'Application submitted successfully', life: 3000 });

            this.showCompleteDialog = true;
            this.loading = false;
            this.resetForm();
            this.$router.push({ name: 'Complete', params: { params: 'success' } });

          } else {

            this.errorMessage = "Unable to submit application"
            this.showErrorDialog = true;
            this.loading = false;

            this.loading = false;
          }
        } catch (error) {



          this.errorMessage = "Unable to submit application"
          this.showErrorDialog = true;
          this.loading = false;

          this.loading = false;
        }

      }
    },

    async saveProgress() {
      //const result = await this.v$.$validate()
      //this.v$.$touch();


      if (this.fieldsEmpty()) {
        //const result = await this.v$.$validate()
        window.scrollTo({ top: 250, behavior: 'smooth' });
        this.$toast.add({ severity: 'error', summary: 'Mandatory Fields', detail: 'Kindly fill out the Contact Information section before saving progress', life: 6000 });
        // this.confirm1();
      } else {
        this.saving = true;
        try {
          this.formData.owners = JSON.stringify(this.ownership)
          this.formData.other_documents = JSON.stringify(this.other_docs)
          const response = await axios.post(endpoints.save, this.formData);

          if (response.data.code == "00") {
            //alert('Form submitted successfully');
            // this.showSuccessDialog = true;
            //window.location.replace("https://jcs.com.gh");
            //this.confirm1();

            this.token = '';
            this.retrieval_email = '';
            this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Application saved successfully', life: 4000 });

            this.resetForm();
            //this.activateModule('start');

            this.saving = false;
            this.$router.push({ name: 'Complete', params: { params: 'update' } });

          } else {


            if (response.data.message) {
              this.errorMessage = response.data.message;
            } else {
              this.errorMessage = "Unable to save form at this time. Kindly retry later";
            }


            this.showErrorDialog = true;
            //alert("error submitting");
            //console.error('Error submitting form:', error);
            // Handle error (e.g., display an error message)
            this.saving = false;
          }
        } catch (error) {

          this.errorMessage = "Unable to save form at this time. Kindly retry later";
          this.showErrorDialog = true;
          //alert("error submitting");
          //console.error('Error submitting form:', error);
          // Handle error (e.g., display an error message)
          this.saving = false;


        }

      }


    },


    async updateApplication() {

      if (this.fieldsEmpty()) {
        window.scrollTo({ top: 250, behavior: 'smooth' });
        this.$toast.add({ severity: 'error', summary: 'Mandatory Fields', detail: 'Kindly fill out the Contact Information section before saving progress', life: 6000 });
      } else {

        this.saving = true;
        try {
          this.formData.owners = JSON.stringify(this.ownership);
          this.formData.other_documents = JSON.stringify(this.other_docs)
          const response = await axios.post(endpoints.update, this.formData);
          //alert('submitted');
          //console.log('Form submitted successfully:', response.data.token);
          // Handle successful submission (e.g., navigate to a success page)

          if (response.data.code == "00") {
            //alert('Form submitted successfully');
            // this.showSuccessDialog = true;

            //this.confirm1();
            //this.successMessage="Application saved successfully";
            //this.showSuccessDialog = true;
            this.token = '';
            this.retrieval_email = '';
            this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Application saved successfully', life: 4000 });

            //this.activateModule('start');


            if (this.autoSaveInterval) {
              clearInterval(this.autoSaveInterval);
            }

            this.$router.push({ name: 'Complete', params: { params: 'update' } });
            this.saving = false;
            // this.resetForm();
          }
        } catch (error) {
          this.errorMessage = "Unable to save form at this time. Kindly retry later";
          this.showErrorDialog = true;
          //alert("error submitting");
          //console.error('Error submitting form:', error);
          // Handle error (e.g., display an error message)
          this.saving = false;


        }
      }
    },


    async autoSave() {

      if (!this.fieldsEmpty()) {

        if (this.formData.email == this.old_email) {
          this.saving = true;
          try {
            this.formData.owners = JSON.stringify(this.ownership);
            this.formData.other_documents = JSON.stringify(this.other_docs)
            this.formData.sector_json = JSON.stringify(this.formData.sector_json);
            this.formData.subsector_json = JSON.stringify(this.formData.subsector_json);
            const response = await axios.post(endpoints.autosave, this.formData);

            if (response.data.code == "00") {

              this.formData = response.data.record;
              this.ownership = JSON.parse(this.formData.owners);
              this.other_docs = JSON.parse(this.formData.other_documents);
              this.formData.sector_json = JSON.parse(this.formData.sector_json);
              this.formData.subsector_json = JSON.parse(this.formData.subsector_json);
              this.is_update = true;
              //this.$toast.add({ severity: 'success', summary: 'Auto Save', detail: 'Progress Saved', life: 4000 });
              this.saveProgressConfirmation()
              this.saving = false;

            }
          } catch (error) {
            //this.errorMessage = "Unable to save form at this time. Kindly retry later";
            //this.showErrorDialog = true;
            //alert("error submitting");
            //console.error('Error submitting form:', error);
            // Handle error (e.g., display an error message)
            this.saving = false;

          }
        }
      } else {
        window.scrollTo({ top: 250, behavior: 'smooth' });
        this.$toast.add({ severity: 'error', summary: 'Mandatory Section', detail: 'Some fields are missing or incorrect. Please fix them to proceed', life: 6000 });
        // this.confirm1();
      }



    },

    debouncedAutoSave: debounce(function () {
      this.autoSave();
    }, 1000), // 1000ms debounce time


    // // Auto-save triggered on input, debounced to prevent too many saves
    // triggerAutoSave: debounce(function () {
    //   this.autoSave();
    // }, 1000), // 1-second debounce

    async retrieveForm() {

      if (!this.token || this.token.trim() === '') {
        return;
      }
      let postData = {
        "email": this.retrieval_email,
        "token": this.token
      }
      this.sending_token = true;
      try {
        const response = await axios.post(endpoints.retrieve, postData);



        if (response.data.code == "00") {
          //alert('Form submitted successfully');
          // this.showSuccessDialog = true;

          //this.confirm1();
          this.formData = response.data.record;
          this.ownership = JSON.parse(this.formData.owners);
          this.other_docs = JSON.parse(this.formData.other_documents);
          this.formData.sector_json = JSON.parse(this.formData.sector_json);
          this.formData.subsector_json = JSON.parse(this.formData.subsector_json);
          this.subsectorOptions = this.formData.sector_json.subsectors;
          this.old_email = this.formData.email;
          this.is_update = true;
          this.activateModule('main');
          this.sending_token = false;

        } else {
          this.sending_token = false;
          this.$toast.add({ severity: 'error', summary: 'Mandatory Fields', detail: 'Unable to retrieve form', life: 3000 });
          this.token_received = false;

          this.$router.push({ name: 'Apply', params: { params: 'start' } });

          // this.activateModule('start');
        }
      } catch (error) {
        this.showErrorDialog = true;
        //alert("error submitting");
        //console.error('Error submitting form:', error);
        // Handle error (e.g., display an error message)
        this.sending_token = false;


      }
    },




    async sendToken() {

      if (this.retrieval_email == '') {
        return;
      }
      this.showRetryDialog = false;
      let postData = {
        "email": this.retrieval_email
      }
      this.sending_token = true;
      try {
        const response = await axios.post(endpoints.sendtoken, postData);
        //alert('submitted');

        // Handle successful submission (e.g., navigate to a success page)

        if (response.data.code == "00") {
          //alert('Form submitted successfully');


          this.successMessage = "Token sent successfully."
          this.showSuccessDialog = true;
          this.sending_token = false;
          this.token_received = true; // hide email text
          this.canResendToken = false // Hide resend
          this.startCountDown()
          // this.resetForm();
        } else if (response.data.code == "02") { // record not found
          //alert('hello')
          this.recordNotFound();


        } else {
          this.errorMessage = 'Unable to send token at this time. Try again later';
          this.token = '';
          this.showErrorDialog = true;
          this.sending_token = false;
        }
      } catch (error) {

        this.showRetryDialog = true;
        //alert("error submitting");
        //console.error('Error submitting form:', error);
        // Handle error (e.g., display an error message)
        this.sending_token = false;


      }
    },


    resetForm() {
      this.formData.lastname = '';
      this.formData.firstname = '';
      this.formData.othernames = '';
      this.formData.nationality = 'Ghana',
        this.formData.email = '';
      this.formData.street_address = '';
      this.formData.city = '';
      this.formData.region = '';
      this.formData.home_phone = '';
      this.formData.mobile = '';
      this.formData.business_name = '';
      this.formData.business_address = '';
      this.formData.business_digital_address = '';
      this.formData.business_website = '';
      this.formData.socialmedia_handles = '';
      this.formData.business_type = '';
      this.formData.male_staff = '';
      this.formData.female_staff = '';
      this.formData.expected_staff_size = '';
      this.formData.sales_revenue_2021 = '';
      this.formData.sales_revenue_2022 = '';
      this.formData.sales_revenue_2023 = '';
      this.formData.ebitda_2021 = '';
      this.formData.ebitda_2022 = '';
      this.formData.ebitda_2023 = '';
      this.formData.debt = '';
      this.formData.equity = '';
      this.formData.registered_company = '';
      this.formData.registration_year = '';
      this.formData.registration_id = '';
      this.formData.gra = '';
      this.formData.gra_tin = '';
      this.formData.funding_beneficiary = '';
      this.formData.funder = '';
      this.formData.audited_business = '';
      this.formData.auditor_name = '';
      this.formData.sector = '';
      this.formData.other_sector = '';
      this.formData.business_description = '';
      this.formData.owners = '';
      this.formData.special_skills = '';
      this.formData.how_know_us = '';
      this.formData.referral_institution = '';
      this.formData.comments = '';
      this.formData.business_certificate = '';
      this.formData.financial_statement1 = '';
      this.formData.financial_statement2 = '';
      this.formData.financial_statement3 = '';
      this.formData.business_plan = '';
      this.formData.financial_projections = '';
      this.formData.letter_of_interest = '';
      this.formData.owners = '';
      this.ownership = [{
        name: '',
        percentage: '',
        role: ''
      }];
    },

    //confirmations
    confirm1(event) {
      this.$confirm.require({
        target: event.currentTarget,
        message: 'Form submitted successfully',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        rejectClass: 'p-button-secondary p-button-outlined',
        rejectLabel: 'OK',
        acceptLabel: 'OK',
        accept: () => {
          //this.$toast.add({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
          // window.location.replace("https://jcs.com.gh");

        },
        // reject: () => {
        //     this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
        // }
      });
    },

    submitConfirmation() {
      this.$confirm.require({
        // target: event.currentTarget,
        message: 'Submit application?',
        header: 'Confirm Submission',
        icon: 'pi pi-info-circle text-primary',
        rejectClass: 'p-button-secondary p-button-outlined',
        rejectLabel: 'No',
        acceptLabel: 'Yes',
        accept: () => {
          //this.$toast.add({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
          // window.location.replace("https://jcs.com.gh");
          this.handleSubmit();
        },
        // reject: () => {
        //     this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
        // }
      });
    },


    saveProgressConfirmation() {
      this.$confirm.require({
        // target: event.currentTarget,
        message: 'Progress Saved. Would you like to exit?',
        header: 'Application Saved',
        icon: 'pi pi-info-circle text-primary',
        rejectClass: 'p-button-secondary',

        rejectLabel: 'Continue',
        acceptLabel: 'Exit',
        accept: () => {
          this.$router.push({ name: 'Home' });
          //this.$toast.add({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
          // window.location.replace("https://jcs.com.gh");
          //this.handleSubmit();
        },
        // reject: () => {
        //     this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
        // }
      });
    },

    emailDuplicateDialog() {
      this.$confirm.require({
        //target: event.currentTarget,

        message: 'This email is already in our records. Would you like to resume your saved application?',
        header: 'Duplicate Record',
        icon: 'pi pi-info-circle text-yellow-500',
        rejectClass: 'p-button-secondary p-button-outlined',
        rejectLabel: 'No',
        acceptLabel: 'Yes',
        accept: () => {
          //this.$toast.add({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
          this.$router.push({ name: 'Home' });

        },
        // reject: () => {
        //     this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
        // }
      });
    },


    recordNotFound() {
      this.$confirm.require({
        //target: event.currentTarget,
        message: 'Record was not found. Would you like to start a new application?',
        header: 'Not Found',
        icon: 'pi pi-info-circle text-yellow-600',
        rejectClass: 'p-button-secondary p-button-outlined',
        rejectLabel: 'No',
        acceptLabel: 'Yes',
        accept: () => {

          this.$router.push({ name: 'Home' });
          //window.location.replace("https://jcs.com.gh");

        },
        reject: () => {
          this.sending_token = false;
        }
      });
    },


    confirm2() {
      this.$confirm.require({
        message: 'Do you want to delete this record?',
        header: 'Danger Zone',
        icon: 'pi pi-info-circle',
        rejectLabel: 'Cancel',
        acceptLabel: 'Delete',
        rejectClass: 'p-button-secondary p-button-outlined',
        acceptClass: 'p-button-danger',
        accept: () => {
          this.$toast.add({ severity: 'info', summary: 'Confirmed', detail: 'Record deleted', life: 3000 });
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
        }
      });
    },

    onAdvancedUpload() {
      this.$toast.add({ severity: 'info', summary: 'Success', detail: 'File Uploaded', life: 3000 });
    },

    async onFileSelect(event) {
      const file = event.files[0];
      if (!file) return;

      const formData = new FormData();
      formData.append('file', file);

      try {
        const response = await axios.post(endpoints.uploadphoto + "/profile", formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: progressEvent => {
            this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          }
        });

        // Assuming the API returns an object with the file path
        // this.filePath = response.data.filePath;
        // console.log(response.data);
        this.formData.photo = response.data;
      } catch (error) {
        console.error('Error uploading file:', error);
        // Handle error accordingly
      } finally {
        // Reset the upload progress after completion
        this.uploadProgress = 0;
      }
    },

    onRemoveTemplatingFile(file, removeFileCallback, index) {
      removeFileCallback(index);
      this.totalSize -= parseInt(this.formatSize(file.size));
      this.totalSizePercent = this.totalSize / 10;
    },

    activateModule(module) {



      if (module == 'main') {

        this.main = true;
        this.start = false;
        this.resume = false
      } else if (module == 'start') {

        this.main = false;
        this.start = true;
        this.resume = false
      } else if (module == 'resume') {

        if (this.autoSaveInterval) {
          clearInterval(this.autoSaveInterval);
        }
        this.main = false;
        this.start = false;
        this.resume = true
      }
    },


    onUpload(event, field) {

      this.formData[field] = event.xhr.response;

    },

    onOtherUpload(event) {

      //this.formData[field] = event.xhr.response;
      //this.other_docs.push(event.xhr.response)
      let url = event.xhr.response

      let name = this.other_doc_name

      if (name == 'Other') {
        name = this.other_doc_name_specify;
      }
      //console.log(url)
      this.other_docs.push({ name: name, url: url });
      this.other_doc_name = ''
      this.other_uploading = false;
    },

    onOtherUploadSelected() {
      // if(){

      // }
      this.other_uploading = true;
    },

    checkEmptyDocName() {
      if (this.other_doc_name == '' && this.other_doc_name_specify == '') {
        alert('Please enter Document Category before selecting file')
      }
    },

    fieldsEmpty() { // checks if mandatory fields for saving are empty


      this.v$.formData.lastname.$touch();
      this.v$.formData.firstname.$touch();
      this.v$.formData.email.$touch();
      this.v$.formData.street_address.$touch();
      this.v$.formData.city.$touch();
      this.v$.formData.region.$touch();
      this.v$.formData.mobile.$touch();
      // this.v$.formData.home_phone.$touch();

      if (
        this.v$.formData.lastname.$error ||
        this.v$.formData.firstname.$error ||
        this.v$.formData.email.$error ||
        this.v$.formData.street_address.$error ||
        this.v$.formData.city.$error ||
        this.v$.formData.region.$error ||
        this.v$.formData.mobile.$error
        //this.v$.formData.home_phone.$error 
      ) {

        return true
      } else {
        return false;
      }

      //   if (this.formData.firstname == '' || 
      //   this.formData.lastname == '' || 
      //   this.formData.email == '' || 
      //   this.formData.mobile == '' ||
      //   this.formData.mobile == '' ||
      //   this.formData.mobile == '' ||
      //   this.formData.mobile == '' ||

      // ) {

      //     return true
      //   } else {

      //     return false;
      //   }



    },

    fieldsEmptyAuto() { // autosave mandatory check


      if (this.formData.firstname == '' ||
        this.formData.lastname == '' ||
        this.formData.email == '' ||
        this.formData.street_address == '' ||
        this.formData.city == '' ||
        this.formData.region == '' ||
        this.formData.mobile == '') {

        return true
      } else {

        return false;
      }



    },

    addOwner() {
      // Add a new blank owner to the owners array
      this.ownership.push({ name: '', percentage: '', role: '' });
    },
    removeOwner(index) {
      // Remove owner at the specified index
      this.ownership.splice(index, 1);
    },

    removeOtherDoc(index) {
      // Remove owner at the specified index
      this.other_docs.splice(index, 1);
    },

    completeRedirect() {
      this.showCompleteDialog = false;
      window.location.replace("https://greenfinancefacilitator.com");

    },

    formatSize(bytes) {
      const k = 1024;
      const dm = 3;
      const sizes = this.$primevue.config.locale.fileSizeTypes;

      if (bytes === 0) {
        return `0 ${sizes[0]}`;
      }

      const i = Math.floor(Math.log(bytes) / Math.log(k));
      const formattedSize = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));

      return `${formattedSize} ${sizes[i]}`;
    },
    downloadForm(format) {
      // Path to your PDF file

      let filePath = "https://greenfinancefacilitator.com/documents/The_GFF_Application_Form.pdf";
      let filename = "GFF_Application_Form.pdf"
      if (format == 'excel') {
        filePath = "https://greenfinancefacilitator.com/documents/The_GFF_Application_Form.xlsx"
        filename = "GFF_Application_Form.xlsx"
      }
      // Create an invisible link element
      const link = document.createElement("a");
      link.href = filePath;
      link.download = "file.pdf"; // Specify the file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    async checkEmailDuplicate(event) {
      this.v$.formData.email.$touch()
      if (this.old_email != this.formData.email) {


        if (!this.v$.formData.email.$error) {

          let email = encodeURIComponent(this.formData.email);
          let url = endpoints.checkemailexists + email
          //this.sending_token = true;
          try {
            const response = await axios.get(url);

            if (response.data == true) {

              this.emailDuplicateDialog()
              this.formData.email = '';
              this.v$.formData.email.$touch();

            } else {
              if (this.old_email != this.formData.email) {

                this.old_email = this.formData.email; //store this for autosave security check
              }


            }
          } catch (error) {
            // console.log(error)
            //this.showErrorDialog = true;



          }
        }
      }






    },
    startCountDown() {
      let duration = parseInt(this.$route.query.duration) || 5; // in minutes
      let minutes = 60 * duration;
      let timer = minutes;
      let seconds;
      var self = this;
      const interval = setInterval(function () {
        minutes = parseInt(timer / 60, 10);
        seconds = parseInt(timer % 60, 10);
        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        self.countDown = minutes + ":" + seconds;
        if (--timer < 0) {
          clearInterval(interval);
          self.tokenExpired = "Token has expired";
          self.countDown = "Token has expired";
          self.canResendToken = true;
        }
      }, 1000);
    },

    populateSubsector() {

      this.formData.subsector = "";

      this.subsectorOptions = this.formData.sector_json.subsectors;
      this.formData.sector_code = this.formData.sector_json.code;
      this.formData.sector = this.formData.sector_json.name;
      this.formData.subsector_code = this.formData.sector_json.subsectors[0].code;
      this.formData.subsector = this.formData.sector_json.subsectors[0].name;

      console.log(this.formData.sector_json)


    }




  }


};
</script>



<style>
body {
  background-color: #e9ebec;
  /* background: url('../assets/bg.jpg') center center no-repeat fixed; */
  background-size: cover
}

/* .startcss {
  background: url('../assets/bg.jpg') center center no-repeat fixed;
  background-size: cover
} */

/* .container {
    max-width: 900px;
    margin: 0 auto;
    padding: 20px;
    background-color: rgba(62, 136, 27, 0.527);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    
   
  } */

.text-center {
  text-align: center;
}

.mb-4 {
  margin-bottom: 1.5rem;
}

.mr-4 {
  margin-right: 0.5rem;
}

.mt-5 {
  margin-top: 3rem;
}

.form-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

/* .form-step {
  display: flex;
  flex-direction: column;
  gap: 20px;
} */

.form-group {
  display: flex;
  flex-direction: column;
}

.form-row {
  display: flex;
  gap: 20px;
}

.form-label {
  margin-bottom: 0.5rem;
}

.form-radio-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.radio-label {
  margin-left: 0.5rem;
}

.form-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

video {
  border: 1px solid #ccc;
  border-radius: 10px;
  margin-bottom: 10px;
}

canvas {
  display: none;
}

img {

  border-radius: 10px;
  margin-top: 10px;
}

.error-message {
  color: red;
  margin-top: 10px;
  font-size: medium;
  font-weight: bold;
}

.success-message {
  color: rgba(29, 141, 54, 0.877);
  margin-top: 10px;
  font-size: medium;
  font-weight: bold;
}

video {
  max-width: 100%;
  height: auto;
}

.error-msg {
  margin: 0.2rem;
  color: rgb(218, 61, 61);
  font-size: 0.7rem;
  font-weight: 700
}

.required {
  color: rgb(218, 61, 61);
}

label {
  color: rgb(56, 56, 53);
  font-size: 0.8rem;
  font-weight: 800;
  margin-bottom: 0.2rem;

}

h3 {
  color: rgb(56, 56, 53);
}

nav {
  background-color: #f4f6fb;

}

a {
  text-decoration: none;
  font-weight: bold;
}

a:hover {
  color: #005fa3;
}


/* To remove the shadow completely */
/* .p-card {
  box-shadow: none !important;
} */

/* Or to apply a lighter shadow */
.p-card {
  border-radius: 8px;
  background: #fff;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.12),
    0 6px 16px rgba(0, 0, 0, 0.08),
    0 20px 40px rgba(0, 0, 0, 0.04);
  transition: box-shadow 200ms ease, transform 200ms ease;
  will-change: transform, box-shadow;
}

/* subtle lift on hover for nicer elevation */
/* .p-card:hover {
  box-shadow:
    0 10px 20px rgba(0, 0, 0, 0.14),
    0 22px 44px rgba(0, 0, 0, 0.10),
    0 40px 80px rgba(0, 0, 0, 0.06);
  transform: translateY(-6px);
} */


</style>